import { useState, useEffect, useRef, useCallback } from 'react'
import "../css/PagesCommonStyle.css"
import { faMagnifyingGlass, faPrint, faCircleCheck, faShieldHalved } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf, faTrashCan, faFile } from '@fortawesome/free-regular-svg-icons'
import { useSelector, useDispatch } from 'react-redux';
import { faTriangleExclamation, faStar, faCircleInfo, faArrowsRotate, faAnglesDown, faAnglesUp, faXmark, faArrowRight, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { APIConstants, IntelliBillConstants, ClaimApprovalConstants, ClaimStatusConstants, CommonAPIConstants, PostingpaymentsConstants, FilesAPIConstants } from '../utilities/Constants'
import * as XLSX from 'xlsx';
import { setUser } from '../redux/actions/userActions'
import { Link } from 'react-router-dom'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import Draggable from 'react-draggable'
import { useParams, useLocation } from 'react-router-dom';
import DebouncedInput from '../common/hook/DebouncedInput'
import { exportExcel } from '../utilities/exportToExcel'


const CPTReport = () => {

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Default value for the input is the current date
    const defaultDate = getCurrentDate();
    const defaultFromDate = new Date('2015-01-01');

    const today = new Date();
    const formatCurDate = format(today, 'MM/dd/yyyy');

    const rowsPerPage = 200;

    const [isHideChecked, setIsHideChecked] = useState(false);
    const [updatedTabledata, setUpdatedTableData] = useState([]);
    const [error, setError] = useState(null);
    const [startDate, setStartDate] = useState(defaultDate, defaultFromDate); // State to store start date
    const [endDate, setEndDate] = useState(defaultDate);     // State to store end date
    const [loading, setLoading] = useState(false);


    const ServiceLocValues = [
        { TextField: 'Office - 11', ValueField: '11' },
        { TextField: 'Home - 12', ValueField: '12' },
        { TextField: 'SUD - 57', ValueField: '57' },
        { TextField: 'Lab - 81', ValueField: '81' },


    ];

    const [ServiceLocations, setServiceLocations] = useState([]);
    const [selectedCMS33a, setSelectedCMS33a] = useState('0');
    const [selectedCMS33b, setSelectedCMS33b] = useState('0');
    const [selectedBillingNPI, setSelectedBillingNPI] = useState('0');
    const [selectedPracticeProvider, setSelectedPracticeProvider] = useState('0');
    const [selectedProvidersCategory, setSelectedProvidersCategory] = useState('0');
    const [selectedSearchFilter, setSelectedSearchFilter] = useState('9');
    const [selectedLocation, setSelectedLocation] = useState('-1');
    const [selectedStatusRadioButton, setSelectedStatusRadioButton] = useState('');
    const [selectedCheckedRadioButton, setSelectedCheckedRadioButton] = useState('0');
    const [selectedServiceLocation, setSelectedServicelocation] = useState('0');
    const [selectedFilterProvider, setSelectedFilterProvider] = useState('0');


    const [locations, setLocations] = useState([]);
    const [cms33aData, setCMS33aData] = useState([]);
    const [cms33bData, setCMS33bData] = useState([]);
    const [providerCategory, setProviderCategory] = useState([]);
    const [searchFilterData, setSearchFilterData] = useState([]);
    const [practiceProvider, setPracticeProvider] = useState([]);
    const [statusRadioButton, setStatusRadioButton] = useState([]);
    const [checkedRadioButton, setCheckedRadioButton] = useState([]);

    const [BillingNPIs, setBillingNPIs] = useState([]);

    const [searchText, setSearchText] = useState('');

    const [suggestions, setSuggestions] = useState([]);
    const [isTextBoxDisabled, setIsTextBoxDisabled] = useState(true);
    const [issuggestionBoxDisabled, setIsSuggestionBoxDisabled] = useState(true);
    const [sPatID, setSPatID] = useState('');
    const [sInsID, setSInsID] = useState('');
    const [sClaimStatus, setsClaimStatus] = useState('');
    const [rowsValidation, setRowsValidation] = useState('');
    const [isChecked, setIsChecked] = useState(false);



    const [tableDetails, setTableDetails] = useState([]);
    const [tableInsDetails, setTableInsDetails] = useState([]);
    const [checkEligibility, setCheckEligibility] = useState([]);
    const [selectedClaims, setSelectedClaims] = useState([]);
    const [selectAllDropdown, setSelectAllDropdown] = useState([]);
    const [checkboxes, setCheckboxes] = useState();


    const [selectedRows, setSelectedRows] = useState([]);

    const [insuranceAllCheckbox, setInsuranceAllCheckbox] = useState([]);
    const [SecInsuranceAllCheckbox, setSecInsuranceAllCheckbox] = useState([]);
    const [filteredTableDetails, setFilteredTableDetails] = useState(tableDetails);


    const [searchByPatient, setSearchByPatient] = useState('');
    const [searchByDOB, setSearchByDOB] = useState('');
    const [searchByInsurance, setSearchByInsurance] = useState('');
    const [searchByProvider, setSearchByProvider] = useState('');
    const [searchByCPT, setSearchByCPT] = useState('');
    const [searchByDOS, setSearchByDOS] = useState('');
    const [searchByPostingDate, setSearchByPostingDate] = useState('');
    const [searchBySubmitdate, setSearchBySubmitdate] = useState('');
    const [searchBySecSubmitdate, setSearchBySecSubmitdate] = useState('');
    const [searchByICD, setSearchByICD] = useState('');
    const [searchByTotalCharge, setSearchByTotalCharge] = useState('');
    const [searchByStatus, setSearchByStatus] = useState('');
    const [searchByRecievedCharge, setSearchByRecievedCharge] = useState('');
    const [searchBySubmitter, setSearchBySubmitter] = useState('');
    const [searchByClaim, setSearchByClaim] = useState('');

    const [searchByUpdatedBy, setSearchByUpdatedBy] = useState('');
    const [searchBySubmittedBy, setSearchBySubmittedBy] = useState('');

    const [searchByDiag1, setSearchByDiag1] = useState('');
    const [searchByDiag2, setSearchByDiag2] = useState('');
    const [searchByDiag3, setSearchByDiag3] = useState('');
    const [searchByDiag4, setSearchByDiag4] = useState('');
    const [searchByMod1, setSearchByMod1] = useState('');
    const [searchByMod2, setSearchByMod2] = useState('');
    const [searchByMod3, setSearchByMod3] = useState('');

    const [selectedTextField, setSelectedTextField] = useState('');
    const [selectedValueField, setSelectedValueField] = useState('');
    const [selectedRecValue, setSelectedRecValue] = useState('all'); // Default value is 25
    const [totalRecords, setTotalRecords] = useState(0);
    const [displayedRecords, setDisplayedRecords] = useState([]);
    const [selectedDropdownValue, setSelectedDropdownValue] = useState('DOS');

    const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [showVerifiedSaveModal, setShowVerifiedSaveModal] = useState(false);
    const [showServiceErrorModal, setShowServiceErrorModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteSuccessModal, setDeleteSuccessModal] = useState(false);
    const [closeClaimsModal, setCloseClaimsModal] = useState(false);
    const [savedRowCount, setSavedRowCount] = useState(0);
    const [deleteRowCount, setDeleteRowCount] = useState(0);
    const [successTimer, setSuccessTimer] = useState(5000);

    const [appointmentDates, setAppointmentDates] = useState([]);
    const [selectLocationID, setSelectLocationID] = useState('-1');
    const [showFilters, setShowFilters] = useState(false);
    const [showDetails, setShowDetails] = useState(false);

    const [claimservices, setClaimServices] = useState([]);
    const [selectedCptValue, setSelectedCptValue] = useState('');
    const [cptValueList, setCptValueList] = useState([]);
    const [selectedCPTCode, setSelectedCPTCode] = useState('');
    const [insOrPatFilter, setInsOrPatFilter] = useState('updatedby');
    const [practiceBillingNPIs, setPracticeBillingNPIs] = useState([]);
    const [selectpracticeBillingNPIs, setSelectPracticeBillingNPIs] = useState('');
    const [selectedViewType, setSelectedViewType] = useState('0');
    const [selectedClaimService, setSelectedClaimService] = useState('0');
    const [isClaimClosed, setIsClaimClosed] = useState('false');

    const [claimFilterRecCountsTableData, setClaimFilterRecCountsTableData] = useState([]);
    const [claimRecCountsTableData, setClaimRecCountsTableData] = useState(claimFilterRecCountsTableData);
    const [defaultUpdatedBy, setDefaultUpdatedBy] = useState('Test Biller');

    const [checkedServices, setCheckedServices] = useState([]);
    const [isNoServiceChecked, setIsNoServiceChecked] = useState(false);

    const [selectedPolicyRows, setSelectedPolicyRows] = useState([]);
    const [selectedInsRows, setSelectedInsRows] = useState([]);
    const [selectedSecInsuranceRows, setSelectedSecInsuranceRows] = useState([]);
    const [selectedAdminWriteRows, setSelectedAdminWriteRows] = useState([]);
    const [selectedWriteOffRows, setSelectedWriteOffRows] = useState([]);
    const [selectedResubmitRows, setSelectedResubmitRows] = useState([]);
    const [transactionCodes, setTransactionCodes] = useState([]);
    const [selectedTransactionCode, setSelectedTransactionCode] = useState('');
    const [verifiedData, setVerifiedData] = useState([]);
    const [selectedVerifiedData, setSelectedVerifiedData] = useState([]);
    const [billingNpiValue, setBillingNpiValue] = useState('');
    const [claimId, setClaimId] = useState('');
    const [cptCode, setCptCode] = useState('');
    const [dos, setDos] = useState('');
    const [savingData, setSavingData] = useState(false);
    const [dataSaved, setDataSaved] = useState(false);

    const [isClaimChecked, setIsClaimChecked] = useState(true);
    const [isSubmitChecked, setIsSubmitChecked] = useState(true);
    const [isNonSubmitChecked, setIsNonSubmitChecked] = useState(true);
    const [isSentChecked, setIsSentChecked] = useState(true);
    const [isPaidChecked, setIsPaidChecked] = useState(true);
    const [isRecvdChecked, setIsRecvdChecked] = useState(true);
    const [isDeniedChecked, setIsDeniedChecked] = useState(true);
    const [isRejectedChecked, setIsRejectedChecked] = useState(true);
    const [isForwardChecked, setIsForwardChecked] = useState(true);
    const [isPostedChecked, setIsPostedChecked] = useState(true);


    const [activeRow, setActiveRow] = useState(null);
    const [selectedServiceIDs, setSelectedServiceIDs] = useState([]);
    const [prevFilter, setPrevFilter] = useState('');
    const [queryFilter, setQueryFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState(null);
    const [selectedAllChecked, setSelectedAllChecked] = useState(false);
    const [selectAllWriteOffChecked, setSelectAllWriteOffChecked] = useState(false);
    const [selectAllAdminWriteChecked, setSelectAllAdminWriteChecked] = useState(false);
    const [selectAllResubmit, setSelectAllResubmit] = useState(false);
    const [selectedData, setSelectedData] = useState('');
    const [isPageLoad, setisPageLoad] = useState('1');
    const [searchByClaimDos, setSearchByClaimDos] = useState('');

    const [showDataModal, setShowDataModal] = useState(false);
    const [eventData, setEventData] = useState([]);
    const [selectedClaimID, setselectedClaimID] = useState([]);
    const [showFaxModal, setShowFaxModal] = useState(false);

    const [reGenerateData, setReGenerateData] = useState(false);
    const [rowState, setRowState] = useState({});
    const [isHidden, setIsHidden] = useState(false);
    const [selectedPatname, setselectedPatname] = useState('');
    const [selectedDOB, setselectedDOB] = useState('');
    const [isStartOpen, setIsStartOpen] = useState(false);
    const [isEndOpen, setIsEndOpen] = useState(false);
    const [searchByLocation, setSearchByLocation] = useState('');
    const [claimID, setClaimID] = useState('');
    const [activeCounts, setActiveCounts] = useState(null);
    const [visibleRecords, setVisibleRecords] = useState(rowsPerPage);
    const [errorMessage, setErrorMessage] = useState("");
    const [showCopaySuccessModal, setShowCopaySuccessModal] = useState(false);
    const [selectedMacro, setselectedMacro] = useState('0');

    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
    const [categoryFilteredClaims, setCategoryFilteredClaims] = useState([]);
    const [allClaims, setAllClaims] = useState([]);
    const tableContainerRef = useRef(null);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const { InsID } = useParams();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const fromDate = queryParams.get('startDate');
    const toDate = queryParams.get('endDate');
    const InsName = queryParams.get('InsName');
    const SearchbyFilter = queryParams.get('selectedSearchFilter');
    const [editedValues, setEditedValues] = useState({});
    const [adjustmentCodeData, setadjustmentCodeData] = useState([]);
    const [attachmentData, setAttachmentData] = useState([]);
    const [showattachmentData, setShowAttachmentData] = useState(false);
    const [attachmentClaimID, setattachmentClaimID] = useState('');

    useEffect(() => {
        if (InsID && fromDate && toDate) {
            setSInsID(InsID);
            setStartDate(fromDate);
            setEndDate(toDate);
            setSPatID(InsID)
            setSearchText(InsName)
            setSelectedSearchFilter(3)
            setInsOrPatFilter(SearchbyFilter)

            handleTableDataClick();

        }
    }, [InsID, fromDate, toDate, selectedSearchFilter, InsName]);



    const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);

    const DashFromDate = hashParams.get('FromDate');
    const DashToDate = hashParams.get('ToDate');
    const statusValue = hashParams.get('FilterValue');



    useEffect(() => {
        const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);
        const DashFromDate = hashParams.get('FromDate');
        const DashToDate = hashParams.get('ToDate');
        const statusValue = hashParams.get('FilterValue');

        if (DashFromDate && DashToDate && statusValue) {
            setStartDate(DashFromDate);
            setEndDate(DashToDate);
            setSelectedStatusRadioButton(statusValue);
            handleTableDataClick();
        }
    }, [DashFromDate, DashToDate, statusValue, selectedStatusRadioButton, startDate, endDate]);






    const sAuthToken = useSelector((state) => state.user.token);



    const loadMoreRecords = useCallback(() => {
        setVisibleRecords((prev) => {
            const next = Math.min(prev + rowsPerPage, displayedRecords.length);


            if (next > prev) {
                setPopupMessage(`${next} records out of ${displayedRecords.length} loaded`);
                setShowPopup(true);


                setTimeout(() => {
                    setShowPopup(false);
                }, 3000);
            }

            return next;
        });
    }, [displayedRecords.length]);


    const handleScroll = useCallback(() => {
        const isAtBottom =
            window.innerHeight + window.scrollY >= document.documentElement.scrollHeight;

        if (isAtBottom) {
            loadMoreRecords();
        }
    }, [loadMoreRecords]);




    useEffect(() => {
        setVisibleRecords(rowsPerPage);
    }, [displayedRecords]);




    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);




    const [totals, setTotals] = useState({
        allClaims: 0,
        totalUnits: 0,
        totalSubmitted: 0,
        totalReceived: 0,
        totalSecReceived: 0,
        totalAdjustmentAmt: 0,
        totalSecPendingAmt: 0,
        totalDeductible: 0,
        totalPatientRes: 0,
        totalWriteOff: 0,
        totalAdminWriteOff: 0,
        totalBalance: 0,
        totalCopay: 0,
        totalOtherAdjustment: 0,
        totalFederalReduction: 0

    });


    const [totalsClaims, setTotalsClaims] = useState({
        allClaims: 0,
        totalSubmitClaim: 0,
        totalNonSubmitted: 0,
        totalSent: 0,
        totalForwarded: 0,
        totalReceivedClaim: 0,
        totalSecReceivedClaim: 0,
        totalDeductibleClaim: 0,
        totalPosted: 0,
        totalPaid: 0,
        totalRejected: 0,
        totalDenied: 0,

    });




    const dispatch = useDispatch();




    const userData = useSelector((state) => state.user.user);


    localStorage.setItem('userData2', JSON.stringify(userData));


    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;



    useEffect(() => {
        document.title = 'CPT Report'


        const initialCheckedServices = claimservices.map((item) => item.ServiceID);
        setCheckedServices(initialCheckedServices);
        setShowServiceErrorModal(false)
    }, [claimservices]);


    useEffect(() => {
        const selectedIds = checkedServices.filter((id) => id !== 0);
        setSelectedServiceIDs(selectedIds);
        setShowServiceErrorModal(false)
    }, [checkedServices]);





    const handleClaimServiceChange = (item) => {


        if (item.ServiceID === '0') {

            setCheckedServices(isNoServiceChecked ? [] : claimservices.map((service) => service.ServiceID));
        } else {

            const updatedServices = checkedServices.includes(item.ServiceID)
                ? checkedServices.filter((selectedId) => selectedId !== item.ServiceID)
                : [...checkedServices, item.ServiceID];
            setCheckedServices(updatedServices);

        }
        updateSelectedServiceIds();
    };




    const updateSelectedServiceIds = () => {
        const selectedIds = checkedServices.includes('0')
            ? checkedServices.filter((id) => id !== '0')
            : checkedServices;

        setSelectedServiceIDs(selectedIds);
    };









    useEffect(() => {
        let timerId;


        if (showSuccessModal || deleteSuccessModal) {
            // Start the timer when the success modal is shown
            timerId = setTimeout(() => {
                setShowSuccessModal(false);
                setDeleteSuccessModal(false);
                setShowServiceErrorModal(false);

            }, successTimer);
        }


        return () => {
            clearTimeout(timerId);
        };
    }, [showSuccessModal, successTimer, deleteSuccessModal]);


    const modalRef = useRef(null);





    useEffect(() => {

        const handleOutsideClick = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowConfirmSaveModal(false);
            }
        };

        // Add event listener
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);









    const handleStartDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setStartDate(formattedDate);
            setIsStartOpen(false)

        } else {
            setStartDate(null);
        }
    };


    const handleEndDateChange = (date) => {

        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setEndDate(formattedDate);

            setIsEndOpen(false)

        } else {
            setEndDate(null);
        }
    };



    const getMonths = (selectedYear) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        return Array.from({ length: 12 }, (v, k) => {
            if (selectedYear === currentYear && k > currentMonth) {
                return null;
            }
            return (
                <option key={k} value={k}>
                    {format(new Date(selectedYear, k), 'MMMM')}
                </option>
            );
        }).filter(option => option !== null);
    };








    const handleTodayClick = (dateType) => {
        const today = new Date();

        if (dateType === "start" && startDate) {
            setStartDate(today);

            setIsStartOpen(false);
        }

        if (dateType === "end" && endDate) {
            setEndDate(today);
            setIsEndOpen(false);
        }
    };



    const CalendarContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("end")}>
                    Today
                </button>

            </div>
        </div>
    );


    const CalendarStartContainer = ({ children }) => (
        <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
            {children}
            <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
                <button type="button" className='today-btn' onClick={() => handleTodayClick("start")}>
                    Today
                </button>

            </div>
        </div>
    );



    const isValidDate = (dateString) => {
        const regEx = /^\d{4}-\d{2}-\d{2}$/;
        return dateString.match(regEx) !== null;
    };

    // Function to format dates as "yyyy-MM-dd"
    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        const formattedMonth = month.padStart(2, '0');
        const formattedDay = day.padStart(2, '0');
        return `${year}-${formattedMonth}-${formattedDay}`;
    };



    const handleHideCheckboxChange = () => {
        setIsHideChecked(!isHideChecked);

        if (isHideChecked) {
            // Reset to original dates
            setStartDate(formatCurDate);
            setEndDate(formatCurDate);
        } else {
            // Set FROM date to 1/1/2015 and TO date to the current date
            setStartDate('1/1/2015');
            setEndDate(formatCurDate);
        }
    };




    // Api Integration of all Dropdowns

    useEffect(() => {


        const storedSelectedStatusRadioButton = localStorage.getItem('selectedStatusRadioButton');
        if (storedSelectedStatusRadioButton) {
            setSelectedStatusRadioButton(storedSelectedStatusRadioButton);
        }

        // Load stored userData from localStorage on component mount
        const storedUserData = localStorage.getItem('userData');
        var inputStruct = {

            LoggedInUserDetails: userData

        }

        var myInput = { sInputJSON: JSON.stringify(userData) };


        myInput = JSON.stringify(myInput);

        const response = fetch(APIConstants.BASE_URL + ClaimApprovalConstants.GetClaimDropDowns, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInput
        })


            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response
                const parsedData = JSON.parse(data.d);
                const dropdownData = parsedData.Data;

                setSelectAllDropdown(dropdownData);
                // Populate the dropdowns with the received data
                setLocations(dropdownData.LocationDetails)

                setCMS33aData(dropdownData.CMSbox33aData);
                setCMS33bData(dropdownData.CMSbox33bData);
                setBillingNPIs(dropdownData.PracticeBillingNPIs);
                setServiceLocations(dropdownData.ServiceLocation);
                setPracticeProvider(dropdownData.PracticeProviders);
                setProviderCategory(dropdownData.ProvidersCategories);
                setSearchFilterData(dropdownData.SearchByFilters);
                setStatusRadioButton(dropdownData.StatusRadioButtons);
                setCheckedRadioButton(dropdownData.CheckedInRadioButtons);
                setLoading(false);


            })

            .catch((error) => {
                console.error('Error fetching data: ', error);
            });

    }, [userData])




    //Fetch the All claim status services

    useEffect(() => {


        var inputStruct = {

            sPracticeID: userPracticeID

        }

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };
        var myInputData = JSON.stringify(myInput);

        const response = fetch(APIConstants.BASE_URL + ClaimStatusConstants.GetClaimServices, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })


            .then((response) => response.json())
            .then((data) => {

                const parsedData = JSON.parse(data.d);
                const serviceData = parsedData.Data;
                setClaimServices(parsedData)
            })

            .catch((error) => {
                console.error('Error fetching data: ', error);
            });

    }, [])


    //Fetch the data of Practice Billing NPIs
    useEffect(() => {


        var inputStruct = {

            LoggedInUserDetails: userData
        }

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };


        var myInputData = JSON.stringify(myInput);

        const response = fetch(APIConstants.BASE_URL + ClaimStatusConstants.GetPracticeBillingNPIs, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })


            .then((response) => response.json())
            .then((data) => {

                const parsedData = JSON.parse(data.d);
                const practiceData = parsedData.Data;

                setPracticeBillingNPIs(practiceData);
            })

            .catch((error) => {
                console.error('Error fetching data: ', error);
            });

    }, [])













    const handleLocationChange = (e, item) => {
        const newSelectedLocation = e.target.value;
        setSelectedLocation(newSelectedLocation || (item.LocationId));
        setSelectLocationID(newSelectedLocation || (item.LocationId));

        localStorage.setItem('selectedLocation', newSelectedLocation);
    };





    const handleRadioButtonsChange = (e) => {

        setSelectedStatusRadioButton(e.target.value);
        localStorage.setItem('selectedStatusRadioButton', e.target.value);
        const selectedValue = e.target.value;
        setsClaimStatus(selectedValue);


    }






    useEffect(() => {

        setsClaimStatus(selectedStatusRadioButton);
        //handleTableDataClick();

    }, [selectedStatusRadioButton, sClaimStatus]);






    const fetchPatientNames = () => {


        var inputJSON = {
            PracticeID: userPracticeID,
            SearchKey: searchText,
            SearchBy: 0,
            isFromLogin: 0
        }

        var sJSONInput = JSON.stringify(inputJSON);


        const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllPatientNames}?sJSONInput=${sJSONInput}`;



        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data);

                const patientData = parsedData.Data;

                if (Array.isArray(patientData)) {
                    setSuggestions
                        (patientData.map((item) => ({
                            label: `${item.LastName}, ${item.FirstName}`,
                            val: item.PatientID,
                        })));

                } else {


                    setSuggestions([]);

                    setIsTextBoxDisabled(false);
                }


            })
            .catch((error) => {
                console.error('Error fetching patient names:', error);
            });
    };









    const fetchUpdatedBy = () => {

        var inputStruct = {


            "sPracticeID": userPracticeID,
            "sUserID": userId,
            "srchKey": searchText


        }

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);


        const response = fetch(APIConstants.BASE_URL + ClaimApprovalConstants.GetSuggestionDropDowns, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const suggestionData = parsedData.Data



                if (suggestionData.length > 0) {
                    setSuggestions(suggestionData.map((item) => ({
                        label: item.split('$')[1],
                        val: item.split('$')[0]
                    })));


                    const defaultSuggestion = suggestionData.find((item) => item === defaultUpdatedBy);
                    if (defaultSuggestion) {
                        setSearchText({
                            label: defaultSuggestion.split('$')[1],
                            val: defaultSuggestion.split('$')[0],
                        });
                    }
                } else {
                    setSuggestions([]);
                    setIsTextBoxDisabled(false);
                }


            })
            .catch((error) => {
                console.error('Error fetching provider names:', error);

            });



    };




    const fetchSubmittedBy = () => {

        var inputStruct = {


            "sPracticeID": userPracticeID,
            "sUserID": userId,
            "srchKey": searchText


        }


        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);


        const response = fetch(APIConstants.BASE_URL + ClaimApprovalConstants.GetSuggestionDropDowns, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const suggestionData = parsedData.Data;

                if (suggestionData.length > 0) {
                    setSuggestions(suggestionData.map((item) => ({
                        label: item.split('$')[1],
                        val: item.split('$')[0]
                    })));
                } else {
                    setSuggestions([]);
                    setIsTextBoxDisabled(false);
                }



            })
            .catch((error) => {
                console.error('Error fetching provider names:', error);

            });



    };





    const fetchSearchProviders = () => {

        // if (!searchProvidersText) {
        //     //If searchText is empty, you may want to reset or clear any existing data
        //     setSearchPatientData([]);
        //     setIsSuggestionBoxDisabled(true);// Disable suggestion box if needed
        //     return;
        // }



        var inputStruct = {

            "sProviderName": searchText,
            "sPracticeID": userPracticeID,
            "LoggedInUserDetails": userData

        }

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        var myInputData = JSON.stringify(myInput);


        const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliProvidersNames, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {
                // Extract the relevant data from the response

                const parsedData = JSON.parse(data.d);

                const providersData = parsedData.Data



                if (Array.isArray(providersData)) {
                    setSuggestions(providersData.map((item) => ({
                        label: (item.split('$')[0]).split('|')[1].trim(),
                        val: item.split('$')[1].trim(),
                    })));
                } else {
                    setSuggestions([]);
                }



            })
            .catch((error) => {
                console.error('Error fetching provider names:', error);

            });
    };







    const fetchInsuranceCompanies = () => {



        var inputJSON = {

            SearchKey: searchText,

        }

        var sJSONInput = JSON.stringify(inputJSON);

        const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetInsuCompanyNames}?sJSONInput=${sJSONInput}`;


        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedData = JSON.parse(data);

                const InsuranceData = parsedData.Data;


                if (Array.isArray(InsuranceData)) {

                    const filteredSuggestions = InsuranceData

                        .map(item => ({
                            label: item.Insurance,
                            val: item.InsuID,
                        }))



                    const filteredData = filteredSuggestions.filter(ins =>
                        ins.label.toLowerCase().includes(searchText.toLowerCase())
                    );


                    setSuggestions(filteredData);

                } else {
                    setSuggestions([]);
                    setIsTextBoxDisabled(false);
                }


                setIsTextBoxDisabled(false);
            })

            .catch((error) => {
                console.error('Error fetching Insurance names:', error);
                setSuggestions([]);

            });

        return [];

    };






    const fetchClearingHouse = () => {



        var inputJSON = {

            SearchKey: searchText,

        }

        var sJSONInput = JSON.stringify(inputJSON);

        const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetClearingHouse}?sJSONInput=${sJSONInput}`;


        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedData = JSON.parse(data);


                console.log("HOUSE", parsedData);


                if (Array.isArray(parsedData)) {

                    const filteredSuggestions = parsedData

                        .map(item => ({
                            label: item.ClearingHouseName,
                            val: item.MCHID,
                        }))



                    const filteredData = filteredSuggestions.filter(item =>
                        item.label.toLowerCase().includes(searchText.toLowerCase())
                    );


                    setSuggestions(filteredData);

                } else {
                    setSuggestions([]);
                    setIsTextBoxDisabled(false);
                }


                setIsTextBoxDisabled(false);
            })

            .catch((error) => {
                console.error('Error fetching Insurance names:', error);
                setSuggestions([]);

            });

        return [];

    };




    //Fetch CPT List


    useEffect(() => {

        fetchCPTList(selectedCptValue);
    }, [selectedCptValue]);


    const cptRef = useRef(null);



    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                cptRef.current &&
                !cptRef.current.contains(event.target) &&
                event.target.tagName !== 'INPUT' &&
                event.target.tagName !== 'SELECT'
            ) {
                setCptValueList([]);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);



    const fetchCPTList = (searchKey) => {
        if (!searchKey) {
            setCptValueList([]);
            return;
        }

        const inputJSON = {
            PracticeID: userPracticeID,
            SearchKey: searchKey,
        };

        const sJSONInput = JSON.stringify(inputJSON);
        const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllCPTList}?sInputJSON=${sJSONInput}`;

        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${sAuthToken}`,
            },
        })
            .then((response) => response.json())
            .then((data) => {
                const parsedData = JSON.parse(data);
                const filteredData = parsedData.filter(item => `${item.CPTCode}` !== selectedCptValue);
                setCptValueList(filteredData);
            })
            .catch((error) => {
                console.error('Error fetching CPT names:', error);
            });
    };




    const handleChange = (e) => {
        const value = e.target.value;
        setSelectedCptValue(value);
        fetchCPTList(value);
    };


    const handleKeyCPTDown = (e) => {
        if (e.key === 'Backspace') {
            const newVal = selectedCptValue.slice(0, -1);
            setSelectedCptValue(newVal);
            fetchCPTList(newVal);
        }

        if (['Enter', 'Escape', 'Tab'].includes(e.key)) {
            setCptValueList([]);
        }
    };

    // Handle list selection
    const handleCPTList = (suggestion) => {
        setSelectedCptValue(suggestion.CPTCode);
        setSelectedCPTCode(suggestion.CPTCode);
        setselectedMacro(suggestion.IsMacro);
        setCptValueList([]);
    };




    const handleSelectBillingNPI = (event) => {
        const selectedValue = event.target.value;
        setSelectedBillingNPI(selectedValue);

    }


    // const filteredProviders = practiceProvider.filter(provider => provider.Supervisor === '1' || provider.Supervisor === '3');

    const handleSelectFilterProviders = (event) => {
        const selectedValue = event.target.value;
        setSelectedFilterProvider(selectedValue);

    }



    const [selectedProvider, setSelectedProvider] = useState('');
    const [tdata, setTdata] = useState('');





    // Function to handle checkbox change
    const handleCheckboxChange = (e) => {
        const value = e.target.checked ? 1 : 0; // Set 1 if checked, 0 if unchecked
        setIsChecked(value);
    };




    useEffect(() => {

        setSelectedCheckedRadioButton('0');
        setSelectedStatusRadioButton('0');
    }, []);

    const handleRadioChange = (e) => {
        setSelectedCheckedRadioButton(e.target.value);
    };



    const processTableData = () => {
        tableDetails.forEach((item) => {

            setRowsValidation(item.DataValidationMessage);
        });
    };





    useEffect(() => {

        if (selectedRecValue === 'all') {
            setDisplayedRecords(filteredTableDetails);
        } else {
            setDisplayedRecords(filteredTableDetails.slice(0, selectedRecValue));
        }
    }, [filteredTableDetails, selectedRecValue]);




    useEffect(() => {
        if (displayedRecords && Array.isArray(displayedRecords)) {
            setTotalRecords(displayedRecords.length);
        } else {
            setTotalRecords(0);
        }
    }, [displayedRecords]);



    const handleSelectChange = (e) => {
        const value = e.target.value;
        setSelectedRecValue(value);
    };





    //Get all total Records of Main Table

    useEffect(() => {
        const parseAmount = (amount) => {
            if (typeof amount === 'string') {
                const cleanedAmount = amount.replace(/\$/g, '').trim();
                return cleanedAmount ? parseFloat(cleanedAmount) : 0;
            }
            if (typeof amount === 'number') {
                return amount;
            }
            return 0;
        };

        // Reset totals to zero before calculating new amounts
        setTotals({
            totalUnits: 0,
            totalSubmitted: 0,
            totalReceived: 0,
            totalWriteOff: 0,
            totalAdminWriteOff: 0,
            totalAdjustmentAmt: 0,
            totalSecPendingAmt: 0,
            totalBalance: 0,
            totalSecReceived: 0,
            totalDeductible: 0,
            totalPatientRes: 0,
            totalCopay: 0,
            totalOtherAdjustment: 0,
            totalFederalReduction: 0
        });

        // Loop through displayedRecords to calculate new totals
        displayedRecords.forEach((claim) => {
            const curRowunits = claim['Units']?.trim();
            const curRowCharges = claim['totalcharge'];
            const totalReceived = claim['recvdCharge'];
            const curRowWriteOff = claim['WriteOffAmount'];
            const curRowBalance = claim['claimbln'];
            const AdminWriteOff = claim['AdminWriteOff'];
            const totalDeductible = claim['Deductible'];
            const totalSecReceived = claim['SecrecvdCharge'];
            const PatientRes = claim['PatientAmount'];
            const AdjustmentAmt = claim['Adjustment'];
            const SecPendingAmt = claim['SecPendingAmt'];
            const CopayAmt = claim['Copay'];
            const OtherAdjustment = claim['OtherAdjustment'];
            const FederalReduction = claim['FederalReduction']


            if (curRowunits !== undefined && curRowunits !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalUnits: prevTotals.totalUnits + parseInt(curRowunits) }));

            if (curRowCharges !== undefined && curRowCharges !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalSubmitted: prevTotals.totalSubmitted + parseAmount(curRowCharges) }));

            if (totalReceived !== undefined && totalReceived !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalReceived: prevTotals.totalReceived + parseAmount(totalReceived) }));

            if (totalSecReceived !== undefined && totalSecReceived !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalSecReceived: prevTotals.totalSecReceived + parseAmount(totalSecReceived) }));

            if (AdjustmentAmt !== undefined && AdjustmentAmt !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalAdjustmentAmt: prevTotals.totalAdjustmentAmt + parseAmount(AdjustmentAmt) }));

            if (CopayAmt !== undefined && CopayAmt !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalCopay: prevTotals.totalCopay + parseAmount(CopayAmt) }));

            if (OtherAdjustment !== undefined && OtherAdjustment !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalOtherAdjustment: prevTotals.totalOtherAdjustment + parseAmount(OtherAdjustment) }));

            if (FederalReduction !== undefined && FederalReduction !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalFederalReduction: prevTotals.totalFederalReduction + parseAmount(FederalReduction) }));

            if (SecPendingAmt !== undefined && SecPendingAmt !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalSecPendingAmt: prevTotals.totalSecPendingAmt + parseAmount(SecPendingAmt) }));

            if (totalDeductible !== undefined && totalDeductible !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalDeductible: prevTotals.totalDeductible + parseAmount(totalDeductible) }));

            if (PatientRes !== undefined && PatientRes !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalPatientRes: prevTotals.totalPatientRes + parseAmount(PatientRes) }));

            if (curRowWriteOff !== undefined && curRowWriteOff !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalWriteOff: prevTotals.totalWriteOff + parseAmount(curRowWriteOff) }));

            if (AdminWriteOff !== undefined && AdminWriteOff !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalAdminWriteOff: prevTotals.totalAdminWriteOff + parseAmount(AdminWriteOff) }));

            if (curRowBalance !== undefined && curRowBalance !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalBalance: prevTotals.totalBalance + parseAmount(curRowBalance) }));


        });
    }, [displayedRecords]);





    useEffect(() => {
        const parseAmount = (amount) => {
            if (typeof amount === 'string') {
                const cleanedAmount = amount.replace(/\$/g, '').trim();
                return cleanedAmount ? parseFloat(cleanedAmount) : 0;
            }
            if (typeof amount === 'number') {
                return amount;
            }
            return 0;
        };

        // Reset totals to zero before calculating new amounts
        setTotalsClaims({
            allClaims: 0,
            totalSubmitClaim: 0,
            totalNonSubmitted: 0,
            totalSent: 0,
            totalForwarded: 0,
            totalReceivedClaim: 0,
            totalPosted: 0,
            totalPaid: 0,
            totalRejected: 0,
            totalDenied: 0,
            totalCopay: 0,
        });

        // Loop through claimRecCountsTableData to calculate new totals
        claimRecCountsTableData.forEach((claim) => {
            const allClaims = claim['AllClaims'];
            const totalSubmitClaim = claim['Submitted']?.trim();
            const totalNonSubmitted = claim['NonSubmitted'];
            const totalSent = claim['SENT'];
            const totalForwarded = claim['FORWARDED'];
            const totalReceivedClaim = claim['PaymentReceived'];
            const totalPosted = claim['PaymentPosted'];
            const totalPaid = claim['PAID'];
            const totalRejected = claim['REJECTED'];
            const totalDenied = claim['DENIED'];



            if (allClaims !== undefined && allClaims !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, allClaims: prevTotals.allClaims + parseInt(allClaims) }));

            if (totalSubmitClaim !== undefined && totalSubmitClaim !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalSubmitClaim: prevTotals.totalSubmitClaim + parseInt(totalSubmitClaim) }));

            if (totalNonSubmitted !== undefined && totalNonSubmitted !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalNonSubmitted: prevTotals.totalNonSubmitted + parseAmount(totalNonSubmitted) }));

            if (totalSent !== undefined && totalSent !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalSent: prevTotals.totalSent + parseAmount(totalSent) }));

            if (totalForwarded !== undefined && totalForwarded !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalForwarded: prevTotals.totalForwarded + parseAmount(totalForwarded) }));

            if (totalReceivedClaim !== undefined && totalReceivedClaim !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalReceivedClaim: prevTotals.totalReceivedClaim + parseAmount(totalReceivedClaim) }));

            if (totalPosted !== undefined && totalPosted !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalPosted: prevTotals.totalPosted + parseAmount(totalPosted) }));

            if (totalPaid !== undefined && totalPaid !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalPaid: prevTotals.totalPaid + parseAmount(totalPaid) }));

            if (totalRejected !== undefined && totalRejected !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalRejected: prevTotals.totalRejected + parseAmount(totalRejected) }));


            if (totalDenied !== undefined && totalDenied !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalDenied: prevTotals.totalDenied + parseAmount(totalDenied) }));


        });

        // ReloadClaimsData('all')
    }, [claimRecCountsTableData]);



    // Fetch all Transaction Codes

    useEffect(() => {


        var inputStruct = {


        }

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };


        var myInputData = JSON.stringify(myInput);

        const response = fetch(APIConstants.BASE_URL + ClaimStatusConstants.GetTransactionCode, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })


            .then((response) => response.json())
            .then((data) => {

                const parsedData = JSON.parse(data.d);


                setTransactionCodes(parsedData)

            })

            .catch((error) => {
                console.error('Error fetching data: ', error);
            });

    }, [])




    //Filtered the data based on Checkboxes in MainTable


    useEffect(() => {
        let filteredClaimsList = [];

        if (isClaimChecked) {
            var allClaims = [...tableDetails];
            filteredClaimsList = filteredClaimsList.concat(allClaims);


        } else {
            if (isNonSubmitChecked) {
                const nonSubClaims = tableDetails.filter((claims) => claims.SubmitDate === '');
                filteredClaimsList = filteredClaimsList.concat(nonSubClaims);
            }

            if (isSubmitChecked) {
                const submittedClaims = tableDetails.filter((claims) => claims.SubmitDate !== '');
                filteredClaimsList = filteredClaimsList.concat(submittedClaims);
            }

            if (isSentChecked) {
                const sentClaims = tableDetails.filter((claims) => claims.ClaimStatusInt === 3);
                filteredClaimsList = filteredClaimsList.concat(sentClaims);
            }

            if (isForwardChecked) {
                const fwdClaims = tableDetails.filter((claims) => claims.ClaimStatusInt === 5);
                filteredClaimsList = filteredClaimsList.concat(fwdClaims);
            }


            if (isRecvdChecked) {
                const paymentRecvdClaims = tableDetails.filter((claims) => claims.isPaymentReceived);
                filteredClaimsList = filteredClaimsList.concat(paymentRecvdClaims);
            }

            if (isPaidChecked) {
                const paidClaims = tableDetails.filter((claims) => claims.ClaimStatusInt == 1);
                filteredClaimsList = filteredClaimsList.concat(paidClaims);
            }

            if (isRejectedChecked) {
                const rejectedClaims = displayedRecords.filter((claims) => claims.ClaimStatusInt == 2);
                filteredClaimsList = filteredClaimsList.concat(rejectedClaims);
            }

            if (isDeniedChecked) {
                const deniedClaims = displayedRecords.filter((claims) => claims.isDenied == 1);
                filteredClaimsList = filteredClaimsList.concat(deniedClaims);
            }



        }

        setDisplayedRecords(filteredClaimsList);
    }, [isClaimChecked, isNonSubmitChecked, isSubmitChecked, isSentChecked, isForwardChecked, isRecvdChecked, isPaidChecked,
        isRejectedChecked, isDeniedChecked]);











    const handleInputKeyPress = (event) => {
        if (event.key === 'Backspace') {
            // Handle backspace key
            if (searchText === '' && suggestions.length > 0) {
                setSuggestions([]);
            } else {
                //  Remove the last character from searchText
                const updatedSearchText = searchText.slice(0, -1);

                if (selectedSearchFilter === 'pat') {
                    fetchPatientNames(updatedSearchText);
                } else if (selectedSearchFilter === 'updatedby') {
                    fetchUpdatedBy(updatedSearchText);
                } else if (selectedSearchFilter === 'ins') {
                    fetchInsuranceCompanies(updatedSearchText);
                } else if (selectedSearchFilter === 'submittedby') {
                    fetchSubmittedBy(updatedSearchText);
                } else if (selectedSearchFilter === 'renderingprovider') {
                    fetchSearchProviders(updatedSearchText);
                }
                else if (selectedSearchFilter === 'ch') {
                    fetchClearingHouse(updatedSearchText);
                }

            }
        }
    }










    useEffect(() => {
        // Set the default last 7 days' date range
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 7);

        setStartDate(sevenDaysAgo);
        setEndDate(today);

        setSearchText(userData.userFullName)
        setSPatID(userData.userID)

        setisPageLoad(1)



    }, []);



    //Bind the approval table details



    const handleTableDataClick = (DataValidationMessage, selectedServiceIDs) => {


        setLoading(true);
        setActiveCounts(null)



        setSelectedAdminWriteRows([]);
        setSelectedPolicyRows([]);
        setSelectedWriteOffRows([]);
        setSelectedResubmitRows([]);

        setIsClaimChecked(true);
        setIsSubmitChecked(true);
        setIsNonSubmitChecked(true);
        setIsSentChecked(true);
        setIsForwardChecked(true);
        setIsRecvdChecked(true);
        setIsPostedChecked(true);
        setIsPaidChecked(true);
        setIsRejectedChecked(true);
        setIsDeniedChecked(true);

        if (checkedServices.length == 0) {


            setShowServiceErrorModal(true);


        } else {

            const sFilterType = selectedDropdownValue;
            var MissingData = DataValidationMessage;

            if (MissingData != "") {
                console.log("Datavalid", MissingData);
            }


            var strCPTGroups = [];

            var objInput = {

                iPracticeID: userPracticeID + "",
                sFromDate: startDate,
                sToDate: endDate,
                sFilterType: sFilterType,
                sPatientID: sPatID,
                sInsuranceID: sInsID,
                sCPT: selectedCptValue,
                sInsorPatFilter: insOrPatFilter,
                sLocationID: selectLocationID,
                sFilterText: searchText + "",
                ViewType: selectedViewType,
                isClosedClaims: isClaimClosed,
                sService: selectedServiceIDs,
                sCPTGroups: strCPTGroups,
                sClaimStatus: sClaimStatus,
                sDefaultSearch: true,
                roleID: userData.roleID,
                isMacro: selectedMacro,
                iProviderTemplateID: userData.iProviderTemplateID,
                DefaultTimeZoneOffSet: userData.DefaultTimeZoneOffSet

            }





            var myInput = JSON.stringify({ ObjClaims: objInput });

            console.log("Input of" + ClaimStatusConstants.GetClaimStatusData, myInput);

            const url = `${APIConstants.BASE_URL_BILLING}${ClaimStatusConstants.GetClaimStatusData}?sInputJSON=${myInput}`;



            fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sAuthToken}`
                }
            })

                .then((response) => {
                    if (response.status != 200) { console.log("response.status", response.status); }
                    else return response.json();
                })


                .then(data => {



                    const parsedTableData = JSON.parse(data);
                    const tableData = parsedTableData.Data[0];

                    setTableDetails(tableData);
                    setadjustmentCodeData(parsedTableData.Data[2])
                    console.log("Response of" + ClaimStatusConstants.GetClaimStatusData, parsedTableData);
                    setTimeout(() => {
                        setLoading(false);
                        setFilteredTableDetails(tableData);

                    }, 10);

                    const claimCountsData = parsedTableData.Data[1];
                    setClaimFilterRecCountsTableData(claimCountsData)
                    setClaimRecCountsTableData(claimCountsData);
                    console.log("countClaim>>>>>>>>>>>>>>>", claimCountsData);


                    setShowServiceErrorModal(false);

                })

                .catch((error) => {
                    setError('API request failed');
                    setLoading(false);
                })


        }
    }






    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleTableDataClick(0, selectedServiceIDs);
        }
    };




    useEffect(() => {

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [selectedServiceIDs, searchText])








    useEffect(() => {

        if (selectedSearchFilter === '1' && searchText) {

            fetchPatientNames();
        } else if (selectedSearchFilter === '9' && searchText) {
            fetchUpdatedBy();
        } else if (selectedSearchFilter === '3' && searchText) {
            fetchInsuranceCompanies();
        }
        else if (selectedSearchFilter === '8' && searchText) {
            fetchSubmittedBy();
        }
        else if (selectedSearchFilter === '5' && searchText) {
            fetchSearchProviders();
        }
        else if (selectedSearchFilter === '4' && searchText) {
            fetchSubmittedBy();
        }

        else if (selectedSearchFilter == 10 && searchText) {
            fetchClearingHouse();
        }

        else if (selectedSearchFilter == 0 && searchText) {
            handleTableDataClick();
        }


    }, [searchText])










    const handleFilterChange = (event) => {





        setIsTextBoxDisabled(selectedSearchFilter === '');


        setSearchText('');



        setSelectedSearchFilter(event.target.value);
        if (selectedSearchFilter !== '7') {
            setBillingNPIs('');
        }

        // Default value for Updated By
        if (event.target.value === "9") {
            setInsOrPatFilter("updatedby");

        } else {
            // Handle other filter changes
            switch (event.target.value) {
                case "1":
                    setInsOrPatFilter("pat");
                    break;
                case "2":
                    setInsOrPatFilter("claimId");
                    break;
                case "3":
                    setInsOrPatFilter("ins");
                    break;
                case "4":
                    setInsOrPatFilter("verifiedby");
                    break;
                case "5":
                    setInsOrPatFilter("renderingprovider");
                    break;
                case "6":
                    setInsOrPatFilter("verifiedbyall");
                    break;
                case "7":
                    setInsOrPatFilter("billingnpi");

                    break;
                case "8":
                    setInsOrPatFilter("submittedby");
                    break;
                case "10":
                    setInsOrPatFilter("ch");
                    break;

                case "0":
                    setInsOrPatFilter(" ");
                    break;
                default:

                    break;

            }


        }
    };




    const handleSuggestionSelect = (item) => {

        setSearchText(item.label || item.val);

        setSuggestions([]);


        setSPatID(item.val);
        setSInsID(item.val);
    };



    const hasLoadedInitially = useRef(false);




    useEffect(() => {
        if (!hasLoadedInitially.current) {

            return;
        }


        if (hasLoadedInitially.current) {
            handleTableDataClick(searchText, selectedServiceIDs);
            hasLoadedInitially.current = false;
        }

        handleClaimServiceChange(selectedServiceIDs)

    }, [selectedServiceIDs]);




    useEffect(() => {
        if (isPageLoad && !hasLoadedInitially.current) {

            handleTableDataClick(searchText, selectedServiceIDs);

            hasLoadedInitially.current = true; // Mark the initial load as done
        }
    }, [isPageLoad]);
















    const removeHtmlTags = (htmlString) => {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = htmlString;
        return tempElement.textContent || tempElement.innerText;
    };



    const getClassForClaimStatus = (claimStatusFlag) => {
        const cleanClaimStatusFlag = removeHtmlTags(claimStatusFlag);
        switch (cleanClaimStatusFlag) {
            case 'N':
                return 'not-submit-style';
            case 'D':
                return 'denied-style';
            case 'P':
                return 'paid-style';
            case 'F':
                return 'forwarded-style';
            case 'R':
                return 'rejected-style';
            case 'S':
                return 'sent-style';
            default:
                return '';
        }
    };

    const getTitleForClaimStatus = (claimStatusFlag) => {
        const cleanClaimStatusFlag = removeHtmlTags(claimStatusFlag);
        switch (cleanClaimStatusFlag) {
            case 'N':
                return 'Not-Billed';
            case 'D':
                return 'Denied';
            case 'P':
                return 'Paid';
            case 'F':
                return 'Forwarded';
            case 'R':
                return 'Rejected';
            case 'S':
                return 'Sent';
            default:
                return '';
        }
    };




    function getTooltip(html) {
        const match = html.match(/data-title=['"]([^'"]+)['"]/);
        return match ? match[1] : '';
    }

    function stripTags(html) {
        return html.replace(/<[^>]*>/g, '');
    }




    const convertTimestampToDate = (timestamp) => {
        return new Date(parseInt(timestamp.substr(6)));


    }







    const handleRowCheckboxChange = (index) => {
        if (selectedRows.includes(index)) {
            setSelectedRows(selectedRows.filter((selectedRow) => selectedRow !== index));
        } else {
            setSelectedRows([...selectedRows, index]);
        }
    };

    const handleSelectAllChange = () => {
        const allSelected = tableDetails.every((_, index) => selectedRows.includes(index));

        if (allSelected) {

            setSelectedRows([]);
        } else {

            setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));
        }
    };

    // New function to update "Select All" checkbox state based on individual checkboxes
    const updateSelectAllCheckbox = () => {
        const allSelected = tableDetails.every((_, index) => selectedRows.includes(index));
        const someSelected = selectedRows.length > 0 && !allSelected;

        // Update the "Select All" checkbox based on individual checkboxes
        setSelectAllChecked(allSelected);

    };

    // State for "Select All" checkbox
    const [selectAllChecked, setSelectAllChecked] = useState(false);


    // Use useEffect to update "Select All" checkbox state whenever selectedRows changes
    useEffect(() => {
        updateSelectAllCheckbox();
    }, [selectedRows]);



    useEffect(() => {

        return () => setSelectedPolicyRows([]);
    }, []);


    useEffect(() => {

        setSelectAllChecked(selectedPolicyRows.length > 0);
    }, [selectedPolicyRows]);


    const handlePolicySelectAllChange = () => {
        const allSelected = tableDetails.every((_, index) => selectedPolicyRows.includes(index));
        setSelectedAllChecked((prevChecked) => !prevChecked);

        if (allSelected) {
            // Deselect all 

            setSelectedPolicyRows([]);

        } else {
            // Select all checkboxes
            setSelectedPolicyRows(Array.from({ length: tableDetails.length }, (_, index) => index));
        }


    };



    const handlePolicyRowCheckboxChange = (index) => {

        if (selectedPolicyRows.includes(index)) {
            setSelectedPolicyRows(selectedPolicyRows.filter((selectedRow) => selectedRow !== index));
        } else {
            setSelectedPolicyRows([...selectedPolicyRows, index]);
        }
        setSelectAllChecked(false);
    }





    const handleSelectInsuranceAllChange = () => {



        const allSelected = tableDetails.every((_, index) => insuranceAllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setInsuranceAllCheckbox([]);
            setSelectedRows([]);
        } else {
            // Select all checkboxes
            setInsuranceAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

            setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));

        }
    };




    const handleInsuranceRowCheckbox = (index, item) => {

        setClaimID(item.ClaimId)


        if (insuranceAllCheckbox.includes(index)) {
            // If the row is already selected, unselect it
            setInsuranceAllCheckbox(insuranceAllCheckbox.filter((selectedRow) => selectedRow !== index));
            setSelectedInsRows((prevSelectedRows) => prevSelectedRows.filter((selectedRow) => selectedRow !== index));
        } else {
            // If the row is not selected, select it
            setInsuranceAllCheckbox([...insuranceAllCheckbox, index]);
            setSelectedInsRows((prevSelectedRows) => [...prevSelectedRows, index]);
        }
    };





    const handleSelectSecInsuranceAllChange = () => {

        const allSelected = tableDetails.every((_, index) => SecInsuranceAllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setSecInsuranceAllCheckbox([]);
            setSelectedRows([]);
        } else {
            // Select all checkboxes
            setSecInsuranceAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

            setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));

        }
    };


    const handleSecInsuranceCheckboxChange = (index) => {

        if (SecInsuranceAllCheckbox.includes(index)) {

            setSecInsuranceAllCheckbox(SecInsuranceAllCheckbox.filter((selectedRow) => selectedRow !== index));
            setSelectedSecInsuranceRows((prevSelectedRows) => prevSelectedRows.filter((selectedRow) => selectedRow !== index));
        } else {

            setSecInsuranceAllCheckbox([...SecInsuranceAllCheckbox, index]);
            setSelectedSecInsuranceRows((prevSelectedRows) => [...prevSelectedRows, index]);
        }
    }



    // useEffect(() => {

    //     return () => setSelectedWriteOffRows([]);
    // }, []);


    // useEffect(() => {

    //     setSelectAllWriteOffChecked(selectedWriteOffRows.length > 0);
    // }, [selectedWriteOffRows]);


    const handleWriteOffSelectAllChange = () => {
        const openClaims = tableDetails.filter(item => item.iClosed !== 1);

        const allSelected = openClaims.every(openItem =>
            selectedWriteOffRows.some(selected => selected.ClaimId === openItem.ClaimId)
        );

        if (allSelected) {
            // Deselect all open rows (leave any other selected ones untouched if you like)
            setSelectedWriteOffRows(prev =>
                prev.filter(selected => !openClaims.some(open => open.ClaimId === selected.ClaimId))
            );
            setSelectAllWriteOffChecked(false);
        } else {
            // Select all open claim objects
            setSelectedWriteOffRows(openClaims);
            setSelectAllWriteOffChecked(true);
        }
    };





    // const handleWriteOffRowCheckboxChange = (index) => {

    //     if (selectedWriteOffRows.includes(index)) {
    //         setSelectedWriteOffRows(selectedWriteOffRows.filter((selectedRow) => selectedRow !== index));

    //     } else {
    //         setSelectedWriteOffRows([...selectedWriteOffRows, index]);

    //     }
    //     setSelectAllWriteOffChecked(false);
    // }



    // useEffect(() => {

    //     return () => setSelectedAdminWriteRows([]);
    // }, []);

    useEffect(() => {

        setSelectAllAdminWriteChecked(selectedAdminWriteRows.length > 0);
    }, [selectedAdminWriteRows]);





    const handleAdminSelectAllChange = () => {
        const allSelected = tableDetails.every((_, index) => selectedAdminWriteRows.includes(index));
        setSelectAllAdminWriteChecked((prevChecked) => !prevChecked);
        if (allSelected) {
            // Deselect all checkboxes
            setSelectedAdminWriteRows([]);
        } else {
            // Select all checkboxes
            setSelectedAdminWriteRows(Array.from({ length: tableDetails.length }, (_, index) => index));
        }


    };



    const handleAdminRowCheckboxChange = (index) => {

        if (selectedAdminWriteRows.includes(index)) {
            setSelectedAdminWriteRows(selectedAdminWriteRows.filter((selectedRow) => selectedRow !== index));
        } else {
            setSelectedAdminWriteRows([...selectedAdminWriteRows, index]);
        }
        setSelectAllAdminWriteChecked(false);
    }


    useEffect(() => {

        return () => setSelectedResubmitRows([]);
    }, []);



    useEffect(() => {

        setSelectAllResubmit(selectedResubmitRows.length > 0);
    }, [selectedResubmitRows]);


    const handleResubmitAllChange = () => {
        const allSelected = tableDetails.every((_, index) => selectedResubmitRows.includes(index));
        setSelectAllResubmit((prevChecked) => !prevChecked);
        if (allSelected) {
            // Deselect all checkboxes
            setSelectedResubmitRows([]);
        } else {
            // Select all checkboxes
            setSelectedResubmitRows(Array.from({ length: tableDetails.length }, (_, index) => index));
        }


    };



    const handleReSubmitCheckboxChange = (index) => {

        if (selectedResubmitRows.includes(index)) {
            setSelectedResubmitRows(selectedResubmitRows.filter((selectedRow) => selectedRow !== index));
        } else {
            setSelectedResubmitRows([...selectedResubmitRows, index]);
        }
        setSelectAllResubmit(false);
    }






    const handleOpenModal = () => {


        setShowConfirmSaveModal(true);

    };







    const handleCloseModals = () => {
        // Close all modals

        setShowConfirmSaveModal(false);

        setShowVerifiedSaveModal(false);
        setShowSelectErrorModal(false);
        setCloseClaimsModal(false);
        setShowServiceErrorModal(false);
        setShowFaxModal(false);
        setShowDataModal(false)
        setShowCopaySuccessModal(false)
        setShowAttachmentData(false)

    };

    const handleOpenDeleteModal = () => {
        if (selectedRows.length === 0) {


            setShowSelectErrorModal(true);
        } else {


            setShowDeleteModal(true);
        }
    };





    const handleDelete = () => {

        const updatedRows = tableDetails.filter((row, index) => !selectedRows.includes(index));

        setTableDetails(updatedRows);


        setShowDeleteModal(false)
        setDeleteSuccessModal(true)
        setSelectedRows([]);
        setDeleteRowCount(selectedRows.length);
    };







    const formatAppointMentDate = (dateString) => {
        const timestamp = parseInt(dateString.match(/\d+/)[0], 10);
        const date = new Date(timestamp);

        if (isNaN(date.getTime())) {
            return '';
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${month}/${day}/${year}`;
    };






    function getRecievedChargeClass(recievedCharge) {
        if (recievedCharge === 0) {
            return 'nonpaid-claims';
            // } else if (recievedCharge === "") {
            //   return 'paid-claims';
        } else {
            return '';
        }


    }








    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };

    const closeFilters = () => {
        setShowFilters(false);
    };

    const toggleDetails = () => {
        setShowDetails(!showDetails);
    };

    const formatDOSDate = (dateString) => {


        if (!dateString) {
            return ""; // or any default value you want to display for null dates
        }

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return "Invalid Date"; // handle cases where the date string is not valid
        }

        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    };


    const formatSubmitDate = (dateString) => {
        if (!dateString) {
            return ""; // or any default value you want to display for null dates
        }

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return "Invalid Date"; // handle cases where the date string is not valid
        }

        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    };





    const handleOpenVerifiedModal = (item) => {
        setSelectedVerifiedData('');
        if (item.isVerified) {

            setSavingData(true);
            return;
        }


        setClaimId(item.ClaimId);
        setCptCode(item.CPTOld);
        const formattedClaimDOS = formatDOSDate(item.ClaimDOS);

        setDos(formattedClaimDOS)

        setShowVerifiedSaveModal(true);
        setSavingData(true);

    }


    //Saved all Verified  data
    const handleSaveVerifiedData = () => {
        setSavingData(false);



        setSelectedVerifiedData('');

        var inputStruct =
        {
            sPracticeID: userPracticeID,
            sClaimID: claimId,
            Comments: selectedVerifiedData,
            DOS: dos,
            CPTCode: cptCode,
            LoggedInUserDetails: userData
        }

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };
        var myInputData = JSON.stringify(myInput);

        const response = fetch(APIConstants.BASE_URL + ClaimStatusConstants.SaveVerifiedData, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {

                const parsedData = JSON.parse(data.d);


                setSavingData(true);


                const filteredClaims = displayedRecords.filter((claim) => {
                    if (claim.ClaimId == claimId) {
                        claim.isVerified = true;

                    }

                    return true;
                });

                setDisplayedRecords(filteredClaims);
                setShowVerifiedSaveModal(false);


            })
            .catch((error) => {
                console.error('An error occurred:', error);

            })



    };


    const verifiedButtonClassName = savingData ? 'saving' : 'btn-style3 mt-2';




    //Get all table data based on totalStatus Records

    const ReloadClaimsData = (filterType, isTotal, claimDOS) => {
        setLoading(true);
        setDisplayedRecords([]);

        const filteredClaimsData = allClaims.filter((claim) => {
            const curDOS = formatDOSDate(claim["ClaimDOS"]);
            const submitDate = formatSubmitDate(claim.SubmitDate);
            const SecClaimSubmiDate = formatSubmitDate(claim.SecClaimSubmiDate)
            const recvdCharge = claim.recvdCharge;
            if (!isTotal && curDOS === claimDOS) {
                switch (filterType) {
                    case 'all': return true;
                    case 'submit': return submitDate !== "" || SecClaimSubmiDate !== "";
                    case 'nonsubmit': return submitDate === "" && SecClaimSubmiDate === "";
                    case 'sent': return claim["ClaimStatusInt"] == 3;
                    case 'fwd': return claim["ClaimStatusInt"] == 5;
                    case 'paid': return claim["ClaimStatusInt"] == 1 && claim["isDenied"] == 0 && recvdCharge > 0;
                    case 'rejected': return claim["ClaimStatusInt"] == 2;
                    case 'denied': return claim["isDenied"] == 1;
                    case 'recvd': return claim["isPaymentReceived"];
                    case 'posted': return claim["isPaymentPosted"];
                    default: return false;
                }
            } else {
                switch (filterType) {
                    case 'all': return true;
                    case 'submit': return submitDate !== "" || SecClaimSubmiDate !== "";
                    case 'nonsubmit': return submitDate === "" && SecClaimSubmiDate === "";
                    case 'sent': return claim["ClaimStatusInt"] == 3;
                    case 'fwd': return claim["ClaimStatusInt"] == 5;
                    case 'paid': return claim["ClaimStatusInt"] == 1 && claim["isDenied"] == 0 && recvdCharge > 0;
                    case 'rejected': return claim["ClaimStatusInt"] == 2;
                    case 'denied': return claim["isDenied"] == 1;
                    case 'recvd': return claim["isPaymentReceived"];
                    case 'posted': return claim["isPaymentPosted"];
                    default: return false;
                }
            }
        });


        setTimeout(() => {
            setLoading(false);
            setCategoryFilteredClaims(filteredClaimsData);
            setDisplayedRecords(filteredClaimsData);
        }, 500);
    };





    const handleClaimCountsClick = (rowKey) => {
        setActiveCounts(rowKey);
    };



    useEffect(() => {
        setAllClaims(tableDetails);
        setCategoryFilteredClaims(tableDetails);
        setDisplayedRecords(tableDetails);
    }, [tableDetails]);









    useEffect(() => {
        const toLower = val => (typeof val === 'string' ? val.toLowerCase() : val?.toString().toLowerCase());

        const matches = (field, searchVal) =>
            searchVal ? toLower(field)?.includes(searchVal.toLowerCase()) : true;

        const matchesStartsWith = (field, searchVal) =>
            searchVal ? toLower(field)?.startsWith(searchVal.toLowerCase()) : true;



        const matchesNumberField = (field, searchVal) => {
            if (searchVal === '') return true;
            if (searchVal === '0') {
                return Number(field) === 0;
            }


            const fieldStr = field != null ? field.toString().toLowerCase() : '';
            return fieldStr.includes(searchVal.toLowerCase());
        };



        const filteredData = categoryFilteredClaims.filter(item => {
            const dosDate = formatDOSDate(item.ClaimDOS);
            const dobDate = formatDOSDate(item.DOB);
            const submitDate = formatSubmitDate(item.SubmitDate);
            const secSubmitDate = formatSubmitDate(item.SecClaimSubmiDate);
            const paymentChequeDate = formatSubmitDate(item.PaymentChequeDate);
            const secCPTChequeDate = formatSubmitDate(item.SecCPTChequeDate);

            return (
                matches(dosDate, searchByDOS) &&
                matches(item.LocationNickname, searchByLocation) &&
                matches(item.ClaimId, searchByClaim) &&
                matchesStartsWith(item.LastName, searchByPatient) &&
                matches(dobDate, searchByDOB) &&
                matches(item.InsCompNickName, searchByInsurance) &&

                matches(item.CPTOld, searchByCPT) &&
                matchesNumberField(item.totalcharge, searchByTotalCharge) &&

                matches(submitDate, searchBySubmitdate) &&
                matches(secSubmitDate, searchBySecSubmitdate) &&

                matches(item.Diag1, searchByDiag1) &&
                matches(item.Diag2, searchByDiag2) &&
                matches(item.Diag3, searchByDiag3) &&
                matches(item.Diag4, searchByDiag4) &&
                matches(item.Mod1, searchByMod1) &&
                matches(item.Mod2, searchByMod2) &&
                matches(item.Mod3, searchByMod3) &&


                matches(item.UpdaterName, searchByUpdatedBy) &&
                matches(item.SubmitterName, searchBySubmittedBy) &&
                matches(item.providername, searchByProvider) &&
                matches(removeHtmlTags(item.ClaimStatusFlag), searchByStatus)
            );
        });

        const hasSearch =
            searchByDOS || searchByPatient || searchByDOB || searchByInsurance || searchByClaim || searchByProvider ||
            searchByLocation || searchByDiag1 || searchByDiag2 || searchByDiag3 || searchByDiag4 || searchByMod1 || searchByMod2
            || searchByMod3 || searchByCPT || searchByTotalCharge || searchBySubmitdate || searchBySecSubmitdate ||
            searchByUpdatedBy || searchBySubmittedBy ||
            searchByStatus

        setDisplayedRecords(hasSearch ? filteredData : categoryFilteredClaims);

    }, [
        searchByDOS, searchByPatient, searchByDOB, searchByInsurance, searchByClaim, searchByProvider,
        searchByCPT, searchByTotalCharge,
        searchByLocation, searchByDiag1, searchByDiag2, searchByDiag3, searchByDiag4, searchByMod1, searchByMod2,
        searchByMod3,
        searchBySubmitdate, searchBySecSubmitdate, searchByUpdatedBy, searchBySubmittedBy,
        searchByStatus,
        categoryFilteredClaims
    ]);







    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    };






    const formatDateForAPI = (dateString) => {
        if (!dateString) return '';
        const [year, month, day] = dateString.split('-');
        const formattedMonth = (month || '').padStart(2, '0');
        const formattedDay = (day || '').padStart(2, '0');
        return `${formattedMonth}/${formattedDay}/${year}`;
    };







    const handleRowClick = (index) => {
        setActiveRow(index);
    };



    const getVerifiedBy = (name) => {
        if (!name) {
            return ''; // Return an empty string if 'name' is undefined
        }

        return name
            .split(" ")
            .map((word) => (word[0] ? word[0].toUpperCase() : ''))
            .join("");
    };



    const handleClaimCheckboxChange = () => {
        setIsClaimChecked(!isClaimChecked);

    }






    //Filtered the data based on Status in MainTable


    const handleStatusFilterChange = (statusInt) => {
        setStatusFilter(statusInt);


        const filteredRecords = tableDetails.filter((item) => {
            const cleanClaimStatusFlag = removeHtmlTags(item.ClaimStatusFlag);
            switch (statusInt) {
                case 0:
                    return cleanClaimStatusFlag === 'N';
                case 1:
                    return cleanClaimStatusFlag === 'P';
                case 2:
                    return cleanClaimStatusFlag === 'R';
                case 5:
                    return cleanClaimStatusFlag === 'F';
                case 9:
                    return cleanClaimStatusFlag === 'D';

                case 10:
                    return cleanClaimStatusFlag === 'P0';
                case 11:
                    return cleanClaimStatusFlag === 'S0';
                default:
                    return false;
            }
        });

        setDisplayedRecords(filteredRecords);
    };


    const isActive = (status) => {
        return prevFilter === status;
    };



    const handleClosedCheckboxChange = () => {
        setIsClaimClosed(prevState => !prevState);

    };



    const tableCountRef = useRef('');


    const handleCountPrint = () => {
        if (tableCountRef.current) {


            const tableHTML = tableCountRef.current.outerHTML;
            const printWindow = window.open("", "_blank");

            printWindow.document.writeln(`
            <html>
              <head>
                <title class="print-title">Claim Status</title>
                <style>
                  body {
                    font-family: Arial, sans-serif;
                    margin: 10px;
                    font-size: 15px;
                    color: #000;
                  }
      
                  .print-title {
                    text-align: center;
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                    color: #0173b7;
                  }
      
                  .table-container {
                    width: 100%;
                    overflow-x: auto;
                  }
      
                  table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: auto; 
                    word-wrap: break-word;
                  }
      
                  th, td {
                    border: 1px solid black;
                    padding: 5px;
                    text-align: left;
                    font-size: 14px;
                  }
      
                  th {
                    background-color: #f4f4f4;;
                    font-size: 14px;
                    color: white !important;
                    border: 1px solid black;
                    text-align: top;
                    transform-origin: left bottom;
                    height: 120px;
                    
                  }
                  td{
                      font-size:14px
                    }
      
                  @media print {
                    @page {
                      size: A4 landscape;
                      margin: 10mm;
                    }
      
                    .table-container {
                      overflow: visible !important;
                    }
      
                     .hide-on-print {
                      display: none !important;
                    }
      
                    
                    .input{
                      width: 20px !important;
                      color: black;
                      
                    }

                     .input-date{
                      width: 70px !important;
                      color: black;
                      
                    }

                   
                    .show-on-print {
                        width: 30px;
                    }

                    .print-label {

                       display: inline-block;
                        max-width: 40px; 
                        word-wrap: break-word;
                        white-space: normal !important;
                        overflow-wrap: break-word;
                        font-size: 12px;
                     }
                  }
      
                  body {
                      -webkit-print-color-adjust: exact;
                    }
                  }
                </style>
              </head>
              <body>
               
                <div class="table-container">${tableHTML}</div>
                <script>
                  window.onload = function() {
                    window.print();
                  };
                  window.onafterprint = function() {
                    window.close();
                  };
                </script>
              </body>
            </html>
          `);

            printWindow.document.close();
        } else {
            console.error("Table reference is not set.");
        }
    };




    const exportToCountExcel = () => {
        const pagename = 'ClaimStatus';
        const table = tableCountRef.current;
        let sPrintableData = table ? table.innerHTML : '';

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");


        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);


        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExcelFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => response.json()) // Parse the response as JSON
            .then(data => {

                if (data && data[2]) {

                    const url = data[2];
                    window.open(url, '_blank');

                }
            })
            .catch(error => {
                console.error('Export to Excel failed', error);
            });
    };






    const exportToCountPDF = () => {
        const pagename = 'ClaimStatus';
        const table = tableCountRef.current.parentNode;
        let sPrintableData = table ? table.innerHTML : '';

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");


        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);


        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => response.json())
            .then(data => {


                if (data && data[2]) {

                    const url = data[2];
                    window.open(url, '_blank');


                }
            })
            .catch(error => {
                console.error('Export to PDF failed', error);
            });
    };



    const tableRef = useRef('');


    const handlePrint = () => {

        if (!tableRef.current) {
            console.error("Table reference is not set.");
            return;
        }

        setVisibleRecords(filteredTableDetails.length);
        const prevVisibleCount = visibleRecords;

        setTimeout(() => {
            const tableHTML = tableRef.current.outerHTML;
            const printWindow = window.open("", "_blank");

            printWindow.document.writeln(`
            <html>
              <head>
                <title class="print-title">Claim Status</title>
                <style>
                  body {
                    font-family: Arial, sans-serif;
                    margin: 10px;
                    font-size: 15px;
                    color: #000;
                  }
      
                  .print-title {
                    text-align: center;
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                    color: #0173b7;
                  }
      
                  .table-container {
                    width: 100%;
                    overflow-x: auto;
                  }
      
                  table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: auto; 
                    word-wrap: break-word;
                  }
      
                  th, td {
                    border: 1px solid black;
                    padding: 5px;
                    text-align: left;
                    font-size: 14px;
                  }
      
                  th {
                    background-color: #f4f4f4;;
                    font-size: 14px;
                    color: white !important;
                    border: 1px solid black;
                    text-align: top;
                    transform-origin: left bottom;
                    height: 120px;
                    
                  }
                  td{
                      font-size:14px
                    }
      
                  @media print {
                    @page {
                      size: A3 landscape;
                      margin: 10mm;
                    }
      
                    .table-container {
                      overflow: visible !important;
                    }
      
                     .hide-on-print {
                      display: none !important;
                    }
      
                    
                    .input{
                      width: 20px !important;
                      color: black;
                      
                    }

                     .input-date{
                      width: 70px !important;
                      color: black;
                      
                    }

                   

                    .show-icon{
                      font-size: 5px;
                      width: 10px;
                    
                    }

                    .skip-btn{

                       background-color: #c5bcbc !important;
                        color: white !important;
                        text-transform: capitalize;
                        padding: 5px;
                        border-radius: 5px;
                        width: max-content;
                        border: 1px solid white;
                    
                    }

                    .print-label {

                        display: inline-block;
                        max-width: 40px; 
                        word-wrap: break-word;
                        white-space: normal !important;
                        overflow-wrap: break-word;
                        font-size: 12px;
                     }
                  }
      
                  body {
                      -webkit-print-color-adjust: exact;
                    }
                  }
                </style>
              </head>
              <body>
               
                <div class="table-container">${tableHTML}</div>
                <script>
                  window.onload = function() {
                    window.print();
                  };
                  window.onafterprint = function() {
                    window.close();
                  };
                </script>
              </body>
            </html>
          `);

            printWindow.document.close();
            setTimeout(() => {
                setVisibleRecords(prevVisibleCount);
            }, 10);
        }, 10);
    };
    const exportToExcel = () => {
        const rows = displayedRecords.slice(0, tableDetails.length);

        const printableRows = [];

        for (let i = 0; i < rows.length; i++) {
            const item = rows[i];
            if (item.IsCPTMoved == 1) continue;
            const primaryInsuranceCell = `
${item.InsCompNickName || item.Payer || ""}
${item.PayerID || ""}
 ${item.PolicyNumber || ""}
`.trim();
            const secondaryInsuranceCell = `
${item.SecInsCompNickName || item.SecPayer || ""}
${item.SecPayerID || ""}
 ${item.SecInsPolicyNumber || ""}
`.trim();

            const claimHx = item.ClaimHx || "";
            const [prefix = "", suffix = ""] = claimHx ? claimHx.split("$") : ["", ""];

            const recvdChargePri =
                item.recvdCharge !== undefined && item.recvdCharge !== null
                    ? item.recvdCharge
                    : item.recvdCharge === 0
                        ? 0
                        : "";

            const recvdChargeSec =
                item.SecrecvdCharge !== undefined && item.SecrecvdCharge !== null
                    ? item.SecrecvdCharge
                    : item.SecrecvdCharge === 0
                        ? 0
                        : "";

            const adjustmentVal =
                item.Adjustment !== undefined && item.Adjustment !== null
                    ? item.Adjustment
                    : "";

            const secPending =
                editedValues?.[item.ClaimId]?.SecPendingAmt !== undefined
                    ? editedValues[item.ClaimId].SecPendingAmt
                    : item.SecPendingAmt ?? "";

            const copayVal =
                editedValues?.[item.ClaimId]?.Copay !== undefined
                    ? editedValues[item.ClaimId].Copay
                    : item.Copay ?? "";

            // const isWriteOffSelected =
            //   selectedWriteOffRows?.some((r) => r.ClaimId === item.ClaimId) ? "Yes" : "No";

            const isResubmitSelected = selectedResubmitRows?.includes(i) ? "Yes" : "No";

            // const claimStatusFlag = item.ClaimStatusFlag
            //   ? typeof removeHtmlTags === "function"
            //     ? removeHtmlTags(item.ClaimStatusFlag)
            //     : item.ClaimStatusFlag.replace(/<[^>]*>/g, "")
            //   : "";

            const verifiedByText =
                typeof getVerifiedBy === "function"
                    ? getVerifiedBy(item.verifiedBy)
                    : item.verifiedBy || "";

            printableRows.push({
                "#": i + 1,
                Location: item.LocationNickname || "",
                DOS:
                    typeof formatDOSDate === "function"
                        ? formatDOSDate(item.ClaimDOS || item.AppointmentDate)
                        : item.ClaimDOS || item.AppointmentDate || "",
                "Claim ID": item.ClaimId || "",
                "Patient Name":
                    `${item.LastName || ""}${item.LastName && item.FirstName ? ", " : ""}${item.FirstName || ""}`,
                "BH/SUD": item.ClaimConType || "",
                DOB:
                    typeof formatSubmitDate === "function"
                        ? formatSubmitDate(item.DOB)
                        : item.DOB || "",
                "Insurance (Pri)": primaryInsuranceCell,
                "Insurance (Sec)": secondaryInsuranceCell,
                "Clearing House": item.ClearingHouseName || item.ClearingHouse || "",
                "Submit Date (Pri)":
                    typeof formatSubmitDate === "function"
                        ? formatSubmitDate(item.SubmitDate)
                        : item.SubmitDate || "",
                "Submit Date (Sec)":
                    typeof formatSubmitDate === "function"
                        ? formatSubmitDate(item.SecClaimSubmiDate)
                        : item.SecClaimSubmiDate || "",
                "Claim Status": item.ClaimStatus || "",
                //   "Claim Status Flag": claimStatusFlag,
                CPT: item.CPTOld || item.EncCPT || item.CPTCode1 || "",
                Units: item.Units ?? "",
                "Total Charge": item.totalcharge ?? "",
                "Recvd Charge (Pri)": recvdChargePri ?? "",
                "Recvd Charge (Sec)": recvdChargeSec ?? "",
                Adjustment: adjustmentVal,
                "Secondary Pending": secPending,
                Deductible: item.Deductible ?? "",
                "Patient Responsibility": item.PatientAmount ?? "",
                Copay: copayVal,
                "Federal Payment": item.FederalPayment ?? "",
                "WriteOff Amount": item.WriteOffAmount ?? "",
                //   "WriteOff Selected": isWriteOffSelected,
                "Admin Write-off": item.AdminWriteOff ?? "",
                Balance: item.claimbln ?? "",
                "Cheque # (Pri)": item.PaymentChqueNo ?? "",
                "Cheque Date (Pri)":
                    typeof formatDateForInput === "function"
                        ? formatDateForInput(item.PaymentChequeDate)
                        : item.PaymentChequeDate || "",
                "Payer Ref # (Pri)": item.PayerRefNumber ?? "",
                "Cheque # (Sec)": item.SecCPTChequeNumber ?? "",
                "Cheque Date (Sec)":
                    typeof formatDateForInput === "function"
                        ? formatDateForInput(item.SecCPTChequeDate)
                        : item.SecCPTChequeDate || "",
                "Payer Ref # (Sec)": item.SecPayerclaimRefNumber ?? "",
                Provider: item.providername || item.RenderingProvider || "",
                "Updated By": item.UpdaterName ?? "",
                "Submitted By": item.SubmitterName ?? "",
                "Adj/Denial/Rejection Codes": getRemarksDetails(item.ClaimId, item.ClaimCPT)
                    ?.map(code => code.ClaimAdjustmentCode)
                    ?.join(", ") || "",
                Remarks: item.Remarks ?? "",
                "Error Details": item.ErrorDetails ?? "",
                "Attachments": item.Attachments || "",
                "Verified By": verifiedByText,
                "Resubmit Selected": isResubmitSelected,
                Notes: item.ClaimNotes ?? "",
            });
        }

        exportExcel(printableRows, "ClaimStatus", "ClaimStatus");
    };





    const exportToPDF = () => {
        const pagename = 'ClaimStatus';
        const table = tableContainerRef.current.parentNode;
        let sPrintableData = table ? table.innerHTML : '';

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");


        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);


        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => response.json()) // Parse the response as JSON
            .then(data => {


                if (data && data[2]) {

                    const url = data[2];
                    window.open(url, '_blank');


                }
            })
            .catch(error => {
                console.error('Export to PDF failed', error);
            });
    };





    const fetchGetAllEvents = (item) => {

        setselectedClaimID(item.ClaimId)


        var inputJSON = {
            PracticeID: userPracticeID,
            ModuleName: "Billing",
            dtFromDate: startDate,
            dtToDate: endDate,
            DataID: item.ClaimId,
            UserID: 0,
            DateType: "DOS",

        }

        var sInputJSON = JSON.stringify(inputJSON);


        const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetClaimAllEvents}?sJSONInput=${sInputJSON}`;



        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {



                const parsedData = JSON.parse(data);

                const patientData = parsedData.Data;

                setEventData(patientData);

                setShowFaxModal(true);


            })
            .catch((error) => {
                console.error('Error fetching patient names:', error);
            });
    };







    const GetPDFCMS = (item) => {


        const claimFilters = {

            PracticeID: userPracticeID,
            ClaimID: item.ClaimId,
            PatientID: item.PatientID,

        };


        const sInputJSON = JSON.stringify(claimFilters);
        const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.GetPDFCMS1500}?sInputJSON=${sInputJSON}`;


        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then(response => response.json()) // Parse the response as JSON
            .then(data => {

                if (data && data) {

                    const parsedData = JSON.parse(data);
                    const url = parsedData.DocumentURL
                    window.open(url, '_blank');


                }
            })
            .catch(error => {
                console.error(' PDF failed', error);
            });
    };






    const handleRegeneratePDFCMS = (item) => {
        const { ClaimId } = item;


        setRowState((prevState) => ({
            ...prevState,
            [ClaimId]: { isLoading: true, isHidden: false }
        }));


        const objInput = {
            PatientID: item.PatientID,
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,
            PriorSecClaim: item.PriorSecClaim,
            UserTimeZoneOffSet: 300,
            UserID: userId
        };


        const sInputJSON = JSON.stringify({ objClaim: objInput });

        const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.SaveRegeneratePDFCMS1500}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',

            }
        })


            .then((response) => response.json())
            .then((data) => {


                setReGenerateData(data);


                setRowState((prevState) => ({
                    ...prevState,
                    [ClaimId]: { isLoading: false, isHidden: true },
                }));
            })
            .catch((error) => {
                console.error('An error occurred:', error);

                // In case of error, stop the loading but keep the icon visible for retry
                setRowState((prevState) => ({
                    ...prevState,
                    [ClaimId]: { isLoading: false, isHidden: false },
                }));
            });
    };






    const GetProviderPDF = (item) => {

        const claimFilters = {
            PracticeID: userPracticeID,
            PatientID: item.PatientID,
            DOS: formatDOSDate(item.ClaimDOS),
            CPT: item.CPTOld
        };


        const sInputJSON = JSON.stringify({ objPatDetails: claimFilters });

        const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.CPTDcoument}?sInputJSON=${sInputJSON}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sAuthToken}`,
            }
        })

            .then(response => response.json()) // Parse the response as JSON
            .then(data => {

                //if (data.status==200) 
                {

                    const url = JSON.parse(data);
                    window.open(url.DocumentURL, '_blank');


                }
            })
            .catch(error => {
                console.error(' PDF failed', error);
            });
    };



    const handleGetClaimSubmitHx = (item) => {



        const claimHx = item.ClaimHx;
        const [prefix, suffix] = claimHx ? claimHx.split('$') : [];


        const Patname = `${item.LastName},${item.FirstName}`;
        setselectedPatname(Patname)
        setselectedDOB(formatDOSDate(item.DOB))

        const objClaim = {

            iPracticeID: userPracticeID,
            sClaimID: item.ClaimId,
            ClaimHxIndicator: suffix,
            ClaimPriOrSec: item.PriorSecClaim
        }

        var sInputJSON = JSON.stringify(objClaim);

        const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.GetClaimSubmitHx}?sInputJSON=${sInputJSON}`;



        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                if (data) {
                    setShowDataModal(true)
                }


            })
            .catch((error) => {
                console.error('Error fetching patient names:', error);
            });
    };








    const handleDosLinkClick = (item) => {
        const claimId = item.ClaimId;

        localStorage.setItem('selectedClaimItem', JSON.stringify(item));

        const url = `/#/transactionlogs/${claimId}`;
        window.open(url, '_blank');
    };



    const handleLinkClick = (item) => {
        const url = `/#/new-encounter/${item.ClaimId}`;
        window.open(url, '_blank');
    };



    const handlePatLinkClick = (item) => {
        const url = `/#/patient-dashboard/${item.PatientID}/primary-insurance`;

        localStorage.setItem("statusPatientID", item.PatientID);

        window.open(url, '_blank');
    };










    useEffect(() => {
        const filteredData = claimFilterRecCountsTableData.filter(item =>
            (item.DOS && typeof item.DOS === 'string' ? item.DOS.toLowerCase().includes(searchByClaimDos.toLowerCase()) : true)


        );

        setClaimRecCountsTableData(
            searchByClaimDos ? filteredData : claimFilterRecCountsTableData
        );


        if (searchByClaimDos && filteredData.length > 0) {
            setShowDetails(true);
        } else {
            setShowDetails(false);
        }
    }, [searchByClaimDos, claimFilterRecCountsTableData]);







    const getRepeatedClaimIdsWithColors = (records) => {
        const claimIdCount = {};
        const claimIdColors = {};
        let toggleColor = true;

        records.forEach((item, index) => {
            if (claimIdCount[item?.ClaimId]) {
                claimIdCount[item?.ClaimId] += 1;
            } else {
                claimIdCount[item?.ClaimId] = 1;

                // Assign alternating colors to repeated ClaimId groups
                claimIdColors[item?.ClaimId] = toggleColor ? 'lightgrey' : 'gray';
                toggleColor = !toggleColor;
            }
        });

        return { claimIdCount, claimIdColors };
    };

    const { claimIdCount, claimIdColors } = getRepeatedClaimIdsWithColors(displayedRecords);



    const handleSort = (key, accessor) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const sortedData = [...displayedRecords].sort((a, b) => {
            let aValue = accessor ? accessor(a) : a[key];
            let bValue = accessor ? accessor(b) : b[key];


            if (aValue == null) aValue = 0;
            if (bValue == null) bValue = 0;


            if (key.toLowerCase().includes('date') || key.toLowerCase().includes('dob') || key.toLowerCase().includes('dos')) {
                aValue = new Date(aValue);
                bValue = new Date(bValue);
            }

            else if (!isNaN(aValue) && !isNaN(bValue)) {
                aValue = parseFloat(aValue) || 0;
                bValue = parseFloat(bValue) || 0;
            }

            else if (typeof aValue === 'string') {
                aValue = aValue.toUpperCase();
                bValue = typeof bValue === 'string' ? bValue.toUpperCase() : '';
            }

            if (aValue < bValue) return direction === 'asc' ? -1 : 1;
            if (aValue > bValue) return direction === 'asc' ? 1 : -1;
            return 0;
        });

        setSortConfig({ key, direction });
        setDisplayedRecords(sortedData);
    };


    const getRemarksDetails = (ClaimId, CurRowCPT) => {
        if (!adjustmentCodeData?.length) return [];

        return adjustmentCodeData.filter(
            x => x.ClaimId === ClaimId && x.ClaimCPT === CurRowCPT
        );
    };




    const GetDOCPDF = (doc) => {
        window.open(doc.DocumentURL, '_blank');

    };


    return (
        <>



            <div className='main-container' style={{ width: '100%', marginTop: '0px' }}>
                <div className='container-style'>
                    <div className='topnavmenu'>
                        <label className='active-label'>CPT Report</label>
                    </div>

                    <div className='searchfilter-container' style={{ height: '60px' }}>


                        <div className='searchfilter-style'>
                            <div className='date-container mt-2'>


                                <div>


                                    <select name="select" style={{ height: '25px', height: '30px' }}
                                        value={selectedDropdownValue}
                                        onChange={(e) => setSelectedDropdownValue(e.target.value)}
                                    >

                                        <option value="DOS" >DOS</option>

                                        <option value="SubmitDate" >To Approve</option>
                                        <option value="DOSub" >Submit Date</option>
                                    </select>

                                </div>



                                <div className="datepicker-container" style={{ marginLeft: '5px', zIndex: 10 }}>
                                    <label>From:</label>
                                    <DatePicker
                                        selected={startDate ? new Date(startDate) : null}
                                        onChange={handleStartDateChange}
                                        dateFormat="MM/dd/yyyy"
                                        maxDate={new Date()}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        yearDropdownItemNumber={100}
                                        readOnly={isHideChecked}
                                        className={`clnImgTextBoxes ${startDate ? 'default-selected' : ''}`}
                                        placeholderText="MM/dd/yyyy"

                                        calendarContainer={CalendarStartContainer}
                                        open={isStartOpen}
                                        onFocus={() => setIsStartOpen(true)}
                                        onInputClick={() => setIsStartOpen(true)}
                                        onClickOutside={() => setIsStartOpen(false)}
                                        renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                            const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                                            const selectedMonth = selectedDate.getMonth();
                                            const selectedYear = selectedDate.getFullYear();

                                            return (
                                                <div>
                                                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                                        {"<"}
                                                    </button>
                                                    <select
                                                        value={selectedMonth}
                                                        onChange={({ target: { value } }) => changeMonth(Number(value))}
                                                    >
                                                        {getMonths(selectedYear)}
                                                    </select>
                                                    <select
                                                        value={selectedYear}
                                                        onChange={({ target: { value } }) => changeYear(Number(value))}
                                                    >
                                                        {Array.from({ length: 100 }, (v, k) => (
                                                            <option key={k} value={new Date().getFullYear() - k}>
                                                                {new Date().getFullYear() - k}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                                        {">"}
                                                    </button>
                                                </div>
                                            );
                                        }}
                                    />
                                </div>

                                <div className="datepicker-container" style={{ marginLeft: '5px', zIndex: 10 }}>
                                    <label>To:</label>
                                    <DatePicker
                                        selected={endDate ? new Date(endDate) : null}
                                        onChange={handleEndDateChange}
                                        dateFormat="MM/dd/yyyy"
                                        maxDate={new Date()}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        yearDropdownItemNumber={100}
                                        className={`clnImgTextBoxes ${endDate ? 'default-selected' : ''}`}
                                        placeholderText="MM/dd/yyyy"
                                        popperPlacement="bottom-start"
                                        readOnly={isHideChecked}

                                        calendarContainer={CalendarContainer}
                                        open={isEndOpen}
                                        onFocus={() => setIsEndOpen(true)}
                                        onInputClick={() => setIsEndOpen(true)}
                                        onClickOutside={() => setIsEndOpen(false)}
                                        renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                                            const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                                            const selectedMonth = selectedDate.getMonth();
                                            const selectedYear = selectedDate.getFullYear();

                                            return (
                                                <div>
                                                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                                                        {"<"}
                                                    </button>
                                                    <select
                                                        value={selectedMonth}
                                                        onChange={({ target: { value } }) => changeMonth(Number(value))}
                                                    >
                                                        {getMonths(selectedYear)}
                                                    </select>
                                                    <select
                                                        value={selectedYear}
                                                        onChange={({ target: { value } }) => changeYear(Number(value))}
                                                    >
                                                        {Array.from({ length: 100 }, (v, k) => (
                                                            <option key={k} value={new Date().getFullYear() - k}>
                                                                {new Date().getFullYear() - k}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                                                        {">"}
                                                    </button>
                                                </div>
                                            );
                                        }}
                                    />
                                </div>



                                <div>
                                    <label style={{ marginLeft: '25px', marginTop: '3px' }}>All</label>
                                    <input
                                        style={{ marginLeft: '10px' }}
                                        type='checkbox'
                                        checked={isHideChecked}
                                        onChange={handleHideCheckboxChange}
                                    />
                                </div>
                            </div>

                            <div className='locfilter-style mt-2'>

                                <label>Location:</label>
                                <select name="select" style={{
                                    width: '140px', marginLeft: '2px', height: '30px', borderRadius: '5px',
                                    backgroundColor:
                                        selectedLocation !== '-1'
                                            ? (locations.find((loc) => loc.LocationId == selectedLocation)?.Color || '#fff')
                                            : '#fff'
                                }}
                                    value={selectedLocation} onChange={handleLocationChange}>

                                    <option value="-1">
                                        All
                                    </option>

                                    {locations.map((item, index) => (

                                        <option key={index} value={item.LocationId} style={{ backgroundColor: item.Color }}>{item.LocationName}</option>
                                    ))}
                                </select>
                            </div>



                            <div className='suggestfilter-style mt-2'>
                                <div style={{ width: '200px' }}>
                                    <label>Search By:</label>
                                    <select name="select" style={{ width: '110px', height: '30px', color: 'black' }}
                                        value={selectedSearchFilter}
                                        onChange={handleFilterChange}>
                                        <option value="0"> </option>
                                        <option value="1">Patient Name</option>
                                        <option value="2">Claim ID</option>
                                        <option value="3">Insurance</option>
                                        <option value="4">Verified By</option>
                                        <option value="5">Rendering Provider</option>
                                        <option value="6">Verified By all</option>
                                        <option value="7">Billing NPI</option>
                                        <option value="8">Submitted By</option>
                                        <option value="9">Updated By</option>
                                        <option value="10">Clearing House</option>
                                    </select>
                                </div>



                                {selectedSearchFilter === '7' ? (
                                    <div className='practice-style'>


                                        <select name="select" style={{ width: '100px', height: '30px', borderRadius: '5px', marginTop: '1px' }}
                                            value={selectpracticeBillingNPIs}
                                            onChange={(e) => {
                                                setSelectPracticeBillingNPIs(e.target.value)
                                                setSearchText(e.target.value);
                                            }}

                                        >

                                            {practiceBillingNPIs.map((item, index) => (

                                                <option key={index} value={item.NPI}>{item.namewithNPI}</option>
                                            ))}
                                        </select>
                                    </div>
                                ) : (
                                    <div style={{ marginLeft: '1px' }}>
                                        <input
                                            type='text'
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            onKeyDown={handleInputKeyPress}

                                            style={{ width: '100px', height: '30px' }}
                                        />
                                        <div className='autocomplete-style'>
                                            <ul className='sugglist-style' style={{ width: '160px', fontSize: '1rem' }}>
                                                {suggestions.map((suggestion) => (
                                                    <li key={suggestion.val} value={suggestion.val} onClick={() => handleSuggestionSelect(suggestion)}>{suggestion.label}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )}



                            </div>



                            <div className='d-flex'>


                                <div className='status-style mt-2'>

                                    <select style={{ width: '140px', height: '30px', marginTop: '3px' }} value={selectedStatusRadioButton} onChange={handleRadioButtonsChange} >
                                        <option value="">All Claims</option>
                                        <option value="sub">Submitted</option>
                                        <option value="nonsub">Non-Submitted</option>
                                        <option value="5">Forwarded</option>
                                        <option value="1">Paid</option>
                                        <option value="2">Rejected</option>
                                        <option value="deni">Denied</option>
                                        <option value="sec">Sec Claims</option>
                                        <option value="priskip">Primary Skipped</option>
                                    </select>
                                </div>








                                <div className='icon-box mt-2'>
                                    <FontAwesomeIcon style={{ marginTop: '8px', cursor: 'pointer' }} onClick={handlePrint} icon={faPrint} />
                                    <FontAwesomeIcon style={{ marginLeft: '8px', color: 'green', marginTop: '8px', cursor: 'pointer' }} onClick={exportToExcel} icon={faFileExcel} />
                                    <FontAwesomeIcon style={{ marginLeft: '8px', color: 'red', marginTop: '8px', cursor: 'pointer' }} onClick={exportToPDF} icon={faFilePdf} />


                                </div>





                            </div>


                            <div className='searchicon-container' style={{ marginLeft: '10px', marginTop: '8px' }}>
                                <FontAwesomeIcon style={{ marginLeft: '7px', marginTop: '5px', cursor: 'pointer', fontSize: '1.5rem' }}
                                    onClick={(e) => handleTableDataClick(e, selectedServiceIDs)}

                                    icon={faMagnifyingGlass} />
                            </div>
                        </div>




                    </div>

                    {loading && (
                        <div className="overlay">
                            <div className="spinner-container">
                                <div className="spinner-grow text-danger" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-warning" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-info" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    )}





                    <div className="table-container" ref={tableRef}>
                        <table className="fixed-header table table-hover border-secondary table-bordered table-info border responsive mt-1 " ref={tableContainerRef}>



                            <thead>

                                <tr className='align-top'>

                                    <th className=' border-white col-sm col-th  text-white sticky-col-1 ' style={{ backgroundColor: '#0173b7', width: '50px', }}>#</th>
                                    <th className=' border-white col col-th-style  text-white sticky-col-2 ' style={{ backgroundColor: '#0173b7', width: '100px' }} >
                                        <Link className='text-white' onClick={() => handleSort('LocationNickname')}>Location</Link>
                                        <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByLocation}
                                            onChange={(e) => setSearchByLocation(e.target.value)}
                                        />
                                    </th>
                                    <th className=' border-white col col-th-style  text-white sticky-col-3' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                                        <Link className='text-white' onClick={() => handleSort('ClaimDOS')}>DOS</Link>
                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByDOS}
                                            onChange={(e) => setSearchByDOS(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col col-th-style  text-white sticky-col-4' style={{ backgroundColor: '#0173b7', width: '140px' }}>
                                        <Link className='text-white' onClick={() => handleSort('ClaimId')}>Claim #</Link>
                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByClaim}
                                            onChange={(e) => setSearchByClaim(e.target.value)}
                                        />

                                    </th>

                                    <th className=' border-white col-sm col-th text-white sticky-col-5' style={{ backgroundColor: '#0173b7', }}>
                                        <Link className='text-white show-on-print' onClick={() => handleSort('FullName', (item) => `${item.LastName}, ${item.FirstName}`)}>Patient Name</Link>


                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                            className='hide-on-print'
                                            type='text'
                                            placeholder='Search'
                                            value={searchByPatient}
                                            onChange={(e) => setSearchByPatient(e.target.value)}
                                        />

                                    </th>

                                    <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                                        <Link className='text-white' onClick={() => handleSort('DOB')}>DOB</Link>
                                        <br />
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                            className='hide-on-print'
                                            type='text'
                                            placeholder='Search'
                                            value={searchByDOB}
                                            onChange={(e) => setSearchByDOB(e.target.value)}
                                        />
                                    </th>


                                    <th className=' border-white col-sm col-th text-white' style={{ backgroundColor: '#0173b7' }}>
                                        <label className='print-label '>Status</label>

                                        <br />
                                        <div className='hide-on-print'>
                                            <label className={`not-submit-style ${statusFilter === 0 ? 'active' : ''}`} title='Not-Submitted' onClick={() => handleStatusFilterChange(0)}>N</label>
                                            <label className={`denied-style ${statusFilter === 9 ? 'active' : ''}`} title='Denied' onClick={() => handleStatusFilterChange(9)}>D</label>
                                            <label className={`paid-style ${statusFilter === 1 ? 'active' : ''}`} title='Paid' onClick={() => handleStatusFilterChange(1)}>P</label>
                                            <label className={`forwarded-style ${statusFilter === 5 ? 'active' : ''}`} title='Forwarded' onClick={() => handleStatusFilterChange(5)}>F</label>
                                            <label className={`rejected-style ${statusFilter === 2 ? 'active' : ''}`} title='Rejected' onClick={() => handleStatusFilterChange(2)}>R</label>
                                            <label className={`NonPaidClaims ${statusFilter === 10 ? 'active' : ''}`} title='NonPaidClaims' onClick={() => handleStatusFilterChange(10)}>P0</label>
                                            <label className={`NonPaidClaims ${statusFilter === 11 ? 'active' : ''}`} title='NonPaidClaims' onClick={() => handleStatusFilterChange(11)}>S0</label>
                                        </div>
                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByStatus}
                                            onChange={(e) => setSearchByStatus(e.target.value)}
                                        />

                                    </th>


                                    <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>
                                        <Link className='text-white' onClick={() => handleSort('CPTOld')}>CPT</Link>
                                        <br />
                                        <div className=' unpaid-claims'>R</div>

                                        <input style={{ width: '100px', height: '30px', borderRadius: '5px', marginTop: '2px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByCPT}
                                            onChange={(e) => setSearchByCPT(e.target.value)}
                                        />


                                    </th>





                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('providername')}>Provider</Link>
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByProvider}
                                            onChange={(e) => setSearchByProvider(e.target.value)}
                                        />
                                    </th>


                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        ICD1
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByDiag1}
                                            onChange={(e) => setSearchByDiag1(e.target.value)}

                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        ICD2
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByDiag2}
                                            onChange={(e) => setSearchByDiag2(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        ICD3
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByDiag3}
                                            onChange={(e) => setSearchByDiag3(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        ICD4
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByDiag4}
                                            onChange={(e) => setSearchByDiag4(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        Mod1
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByMod1}
                                            onChange={(e) => setSearchByMod1(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        Mod2
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByMod2}
                                            onChange={(e) => setSearchByMod2(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        Mod3
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                            className='hide-on-print'
                                            placeholder='Search'
                                            value={searchByMod3}
                                            onChange={(e) => setSearchByMod3(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('UpdaterName')}>Updated By</Link>
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchByUpdatedBy}
                                            onChange={(e) => setSearchByUpdatedBy(e.target.value)}
                                        />
                                    </th>

                                    <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>
                                        <Link className='text-white' onClick={() => handleSort('SubmitterName')}>Submitted By</Link>
                                        <br />
                                        <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                            className='hide-on-print'
                                            value={searchBySubmittedBy}
                                            onChange={(e) => setSearchBySubmittedBy(e.target.value)}
                                        />
                                    </th>



                                </tr>

                            </thead>


                            <tbody >



                                {displayedRecords.length > 0 ? (
                                    displayedRecords.slice(0, visibleRecords).map((item, index) => {
                                        if (item.IsCPTMoved == 1) return null;

                                        const isClaimIdRepeated = claimIdCount[item.ClaimId] > 1;
                                        const backgroundColor = isClaimIdRepeated ? claimIdColors[item.ClaimId] : '';
                                        const cleanStatus = removeHtmlTags(item.ClaimStatusFlag || "");

                                        const isDeniedOrPartial =
                                            cleanStatus === "D" || cleanStatus === "P0";

                                        const claimHx = item.ClaimHx;
                                        const [prefix, suffix] = claimHx ? claimHx.split('$') : [];

                                        return (
                                            <tr
                                                className={`
                                                    ${item.iClosed === 1
                                                        ? 'table-secondary'
                                                        : item.DataValidationMessage && activeRow !== index
                                                            ? 'table-danger'
                                                            : activeRow === index
                                                                ? 'table-warning'
                                                                : ''
                                                    }
                                               `}
                                                // style={{ backgroundColor: isPrimaryRow ? 'yellow' : '' }}

                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title={item.DataValidationMessage || ''}
                                                key={index}
                                                onClick={() => handleRowClick(index)}


                                            >


                                                <td className='table-bordered border border-white sticky-col-1' scope="row" style={{ fontFamily: 'sans-serif', fontSize: '14px', fontWeight: '500', width: '30px' }}>{index + 1}</td>
                                                <td className='table-bordered border border-white sticky-col-2' style={{ width: '100px' }}><label style={{ backgroundColor: item.LocationColor, padding: "4px 8px", borderRadius: "4px", color: "#fff" }}>{item.LocationNickname}</label></td>
                                                <td className='table-bordered border border-white sticky-col-3' style={{ backgroundColor, width: '120px' }}><label className='linkspan' onClick={() => handleDosLinkClick(item)}>

                                                    {formatDOSDate(item.ClaimDOS)}</label></td>
                                                <td className='table-bordered border border-white sticky-col-4' style={{ backgroundColor, backgroundColor: item.updatedby && item.UpdatedDateTime ? 'lightpink' : '' }}>

                                                    <span onClick={() => handleLinkClick(item)} style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}>
                                                        {item.ClaimId}
                                                    </span>

                                                    {prefix !== "F0" && (
                                                        <Link style={{ marginLeft: '10px' }} onClick={() => handleGetClaimSubmitHx(item)} >{prefix}</Link>
                                                    )}

                                                    <FontAwesomeIcon className='hide-on-print' style={{ marginLeft: '20px', color: '#000', fontWeight: '100' }} onClick={() => fetchGetAllEvents(item)} icon={faFile} />

                                                    {
                                                        !rowState[item.ClaimId]?.isHidden && (
                                                            <FontAwesomeIcon
                                                                style={{ marginLeft: '5px' }}
                                                                onClick={() => handleRegeneratePDFCMS(item)}
                                                                icon={faArrowsRotate}
                                                                className={rowState[item.ClaimId]?.isLoading ? 'rotating-icon hide-on-print' : 'hide-on-print'}
                                                            />
                                                        )
                                                    }

                                                    <FontAwesomeIcon className='hide-on-print' style={{ marginLeft: '10px', color: 'red' }} onClick={() => GetPDFCMS(item)} icon={faFilePdf} />
                                                </td>
                                                <td className='table-bordered border border-white sticky-col-5' style={{ backgroundColor }}>
                                                    <label className={`linkspan print-label ${item.EligibilityCheckCount > 0 ? 'EligibilityChecked' : 'EligibilityNotChecked'}`} onClick={() => handlePatLinkClick(item)}>
                                                        {item.LastName},{item.FirstName}

                                                    </label>

                                                    {item.PatSecInscount > 0 && (
                                                        <span>
                                                            <FontAwesomeIcon className='show-icon' style={{ marginLeft: '10px' }} icon={faShieldHalved} />
                                                        </span>
                                                    )}

                                                </td>


                                                <td className='table-bordered border border-white' style={{ width: '120px' }}><label className='label-style' >{formatSubmitDate(item.DOB)}</label></td>


                                                <td className='table-bordered border border-white'>

                                                    <label>{item.ClaimStatus}</label>

                                                    <label title={getTooltip(item.ClaimStatusFlag)} dangerouslySetInnerHTML={{ __html: item.ClaimStatusFlag }}></label>

                                                </td>

                                                <td className='table-bordered border border-white'><label className='unpaid-claims' style={{
                                                    backgroundColor:
                                                        removeHtmlTags(item.ClaimStatusFlag) === "D" || removeHtmlTags(item.ClaimStatusFlag) === "P0"
                                                            ? "red"
                                                            : item.recvdCharge !== null
                                                                ? "lightgreen"
                                                                : "lightgray",
                                                    color:
                                                        removeHtmlTags(item.ClaimStatusFlag) === "D" || removeHtmlTags(item.ClaimStatusFlag) === "P0"
                                                            ? "white"
                                                            : "black"
                                                }}>{item.CPTOld}</label>

                                                </td>


                                                <td className='table-bordered border border-white'>{item.providername}
                                                    <FontAwesomeIcon className="hide-on-print" style={{ marginLeft: '5px', color: 'red', cursor: 'pointer' }} onClick={() => GetProviderPDF(item)} icon={faFilePdf} />
                                                </td>
                                                <td className='table-bordered border border-white'>{item.Diag1}</td>
                                                <td className='table-bordered border border-white'>{item.Diag2}</td>
                                                <td className='table-bordered border border-white'>{item.Diag3}</td>
                                                <td className='table-bordered border border-white'>{item.Diag4}</td>
                                                <td className='table-bordered border border-white'>{item.Mod1}</td>
                                                <td className='table-bordered border border-white'>{item.Mod2}</td>
                                                <td className='table-bordered border border-white'>{item.Mod3}</td>
                                                <td className='table-bordered border border-white'>{item.UpdaterName}</td>
                                                <td className='table-bordered border border-white'>{item.SubmitterName}</td>


                                            </tr>
                                        )
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "center" }}>No records found</td>
                                    </tr>
                                )}






                            </tbody>



                        </table>





                        {showCopaySuccessModal && (
                            <div className="alertmsg-modal">
                                <label style={{ backgroundColor: "#18A6EC" }}></label>
                                <FontAwesomeIcon
                                    style={{
                                        float: "right",
                                        fontWeight: "bolder",
                                        fontSize: "1rem",
                                        backgroundColor: "red",
                                        padding: "5px",
                                        cursor: "pointer",
                                    }}
                                    onClick={handleCloseModals}
                                    icon={faXmark}
                                />
                                <div style={{ backgroundColor: "#18A6EC", color: "white", padding: "10px" }}>
                                    {errorMessage}
                                </div>
                            </div>
                        )}



                        {showVerifiedSaveModal && (

                            <div className='verified-fax' style={{ zIndex: 10 }}>

                                <textarea placeholder='comments' style={{ width: '300px', height: '80px', borderRadius: '5px' }}
                                    value={selectedVerifiedData}
                                    onChange={(e) => setSelectedVerifiedData(e.target.value)}
                                />
                                <br />
                                <button className='btn-style3 mt-2' onClick={handleCloseModals} >Cancel</button>
                                <button className='btn-style3 mt-2' onClick={handleSaveVerifiedData}>Confirm</button>

                            </div>
                        )}

                    </div>



                    {showServiceErrorModal && (

                        <div className='alert-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>please select atleast one Filter from Service...</p>

                        </div>

                    )}


                    {showSelectErrorModal && (

                        <div className='alert-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>please select atleast one claim...</p>

                        </div>

                    )}




                    {showSuccessModal && (
                        <div className='alert-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>Selected Claim Successfully Closed</p>

                        </div>
                    )}



                    {showPopup && (
                        <div style={{
                            position: 'fixed',
                            bottom: '50px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            backgroundColor: '#333',
                            color: '#fff',
                            padding: '10px 20px',
                            borderRadius: '5px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                            zIndex: 1000,
                            height: '100px',
                            width: '400px',
                            textAlign: 'center'
                        }}>
                            <label style={{ marginTop: '20px', fontSize: '1.4rem' }}>{popupMessage}</label>
                        </div>
                    )}



                    {showFaxModal && (

                        <Draggable>
                            <div className='dialog-box2'>


                                <table className="table" >

                                    <thead>

                                        <tr>
                                            <td className='topnavsub'>
                                                <FontAwesomeIcon style={{ width: '18px', height: '18px', borderRadius: '999px', border: '1px solid black', float: 'right', fontWeight: 'bolder', fontSize: '0.9rem', backgroundColor: 'red', color: 'white' }}
                                                    onClick={handleCloseModals} icon={faXmark} />

                                            </td>

                                        </tr>

                                        <tr >

                                            <td style={{ backgroundColor: '#ECF7FB' }} >   <label >Claim ID:  {selectedClaimID}  </label></td>

                                        </tr>

                                        <tr>

                                            <td>

                                                {eventData.map((item, index) => (
                                                    <>


                                                        <div className='event-style' key={index}>
                                                            <label>{item.DataCurStatus}</label>
                                                            <br />
                                                            <label>{formatDOSDate(item.EventDateTime)}- {item.UserFName}</label>

                                                        </div>

                                                        {index < eventData.length - 1 && (

                                                            <FontAwesomeIcon style={{ fontWeight: 'bolder', fontSize: '1.8rem' }} icon={faArrowRight} />

                                                        )}
                                                    </>
                                                ))}
                                            </td>
                                        </tr>

                                    </thead>

                                    <tbody>



                                    </tbody>


                                </table>


                            </div>
                        </Draggable>


                    )}




                    {showattachmentData && (
                        <Draggable>

                            <div className='modal-box'>
                                <FontAwesomeIcon style={{
                                    width: '18px', height: '18px', borderRadius: '999px', border: '1px solid black',
                                    float: 'right', fontWeight: 'bolder', fontSize: '0.9rem', backgroundColor: 'red', color: 'white'
                                }} onClick={handleCloseModals} icon={faXmark} />

                                <label >Claim ID:  {attachmentClaimID}  </label>

                                <div className=' mt-2'>

                                    <table className="table table-hover table-striped table-bordered border border-white table-info responsive mt-1 " style={{ marginLeft: '5px', width: '100%' }}>

                                        <thead>

                                            <tr className="align-top" style={{ fontSize: "0.5rem" }}>
                                                <th
                                                    className="col-sm col-th  text-white border border-white"
                                                    style={{ backgroundColor: "#0173b7" }}
                                                >
                                                    S NO
                                                </th>

                                                <th
                                                    className="col col-th-style  text-white border border-white"
                                                    style={{ backgroundColor: "#0173b7" }}
                                                >
                                                    Document Name
                                                </th>
                                                <th
                                                    className="col col-th-style  text-white border border-white"
                                                    style={{ backgroundColor: "#0173b7" }}
                                                >
                                                    Preview
                                                </th>
                                                <th
                                                    className="col col-th-style  text-white border border-white"
                                                    style={{ backgroundColor: "#0173b7" }}
                                                >
                                                    Uploaded Date
                                                </th>

                                                <th className="col col-th-style  text-white border border-white"
                                                    style={{ backgroundColor: "#0173b7" }}>Type</th>


                                                <th className="col col-th-style  text-white border border-white"
                                                    style={{ backgroundColor: "#0173b7" }}>Method</th>

                                                <th className="col col-th-style  text-white border border-white"
                                                    style={{ backgroundColor: "#0173b7" }}>ACN</th>


                                            </tr>


                                        </thead>

                                        <tbody>
                                            {attachmentData.map((item, index) => (

                                                <tr

                                                    key={index}
                                                >
                                                    <td>{index + 1}</td>
                                                    <td>{item.documentName}</td>
                                                    <td>
                                                        <FontAwesomeIcon className="hide-on-print" style={{ marginLeft: '5px', color: 'red', cursor: 'pointer' }} onClick={() => GetDOCPDF(item.fileUrl)} icon={faFilePdf} />

                                                    </td>
                                                    <td>{formatDOSDate(item.uploadedDate)}</td>
                                                    <td>
                                                        {item.pwK01}
                                                    </td>
                                                    <td>
                                                        {item.pwK02}
                                                    </td>
                                                    <td>
                                                        {item.pwK06}
                                                    </td>


                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>

                                </div>
                            </div>


                        </Draggable>

                    )}


                    {showDataModal && (

                        <Draggable>
                            <div className='dialog-box3 p-2' >

                                <div className='d-flex'>
                                    <label style={{ fontFamily: 'sans-serif', fontWeight: '600' }}>Patient Name:
                                        <Link>{selectedPatname}</Link>
                                    </label>

                                    <label style={{ fontFamily: 'sans-serif', fontWeight: '600', marginLeft: '60px' }}>DOB: </label>

                                    <label style={{ fontFamily: 'sans-serif', fontWeight: '500', marginLeft: '5px' }}>{selectedDOB}</label>


                                    <div className='topnavsub2'>
                                        <FontAwesomeIcon style={{ width: '18px', height: '18px', borderRadius: '999px', border: '1px solid black', float: 'right', fontWeight: 'bolder', fontSize: '0.9rem', backgroundColor: 'red', color: 'white', marginLeft: '40px' }}
                                            onClick={handleCloseModals} icon={faXmark} />

                                    </div>
                                </div>
                                <table className="table table-bordered border-secondary border-white" >

                                    <thead>

                                        <tr>
                                        </tr>


                                        <tr>

                                            <th className='text-white  border-white' style={{ backgroundColor: '#0173b7', width: '30px', }}>#</th>


                                            <th className='col col-th-style  text-white  border-white' style={{ backgroundColor: '#0173b7', }}>Claim ID

                                            </th>


                                            <th className='col col-th-style  text-white  border-white' style={{ backgroundColor: '#0173b7' }} >DOS


                                            </th>

                                            <th className='col col-th-style  text-white  border-white' style={{ backgroundColor: '#0173b7', }}>Submit Date

                                            </th>


                                            <th className='col col-th text-white  border-white' style={{ backgroundColor: '#0173b7' }}><label style={{ width: '100px' }}>Submit By</label>

                                            </th>


                                        </tr>



                                    </thead>



                                </table>

                            </div>
                        </Draggable>


                    )}











                </div>


            </div>




        </>
    )
}

export default CPTReport;